import React, { useState, useEffect } from "react";

import Moment from 'moment';
import path from 'path';
import { FilePond, registerPlugin } from 'react-filepond';
import axios from 'axios'

import 'filepond/dist/filepond.min.css';

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { provisioners } from '../../settings/shared/constants';
import Pagination from "assets/js/Pagination";
// reactstrap components
import {
  Card,
  CardHeader,
  CardSubtitle,
  CardBody,
  CardFooter,
  Col,
  Collapse,
  Row,
  Button,
  ButtonGroup,
  Breadcrumb,
  BreadcrumbItem,
  UncontrolledTooltip,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Label,
  Popover,
  PopoverHeader,
  PopoverBody,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  UncontrolledPopover,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  FormGroup,
  Badge,
} from "reactstrap";
import CommonService from '../../services/api/Common'
import StorageService from '../../services/api/Storage';
import FileJobsService from '../../services/api/FileJobs';
import StorageConfigService from '../../services/api/StorageConfig';
import { fileSizeSI, storagejobStatusAlert } from '../../settings/shared/commonMethod';
import { confirmAlert } from 'react-confirm-alert'; // Import
import Switch from "react-bootstrap-switch";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import TinyURL from "tinyurl";
import moment from 'moment'
import { default_StorageName, default_LabelStorageName, provisionerService, STORAGE_DEFAULT_MOUNT_PATH, STORAGE_EXTERNAL_MOUNT_PATH } from '../../settings/shared/constants';
import { toast } from 'react-toastify';
import 'axios-progress-bar/dist/nprogress.css'
import Select from "react-select";
import { Scrollbars } from 'react-custom-scrollbars';
import "../notebooks/notebook.min.css";
import page404 from "assets/img/404.png";
import awsbucket from "assets/img/awsbucket.png";
import undefinedfile from "assets/img/undefined.PNG";
import unknownfile from "assets/img/undefinedfile.PNG";
import 'c3/c3.css';
import cloading from "assets/img/cloading2.gif";
import { findIcon, imageFileExtension, provisionerTypeLogo, CSVToJSONs } from "../../settings/shared/commonMethod";
import { uuidv4 } from '../../components/Notebook/operations/notebook'
import ReactPaginate from 'react-paginate';
import RunService from '../../services/api/Run';
import ProvisionerService from "../../services/api/Provisioner";
import { Drawer } from 'antd';
import { HotTable } from "@handsontable/react";
import { HandsonTableKey } from '../../settings/shared/constants';
import { HyperFormula } from 'hyperformula';
import * as XLSX from "xlsx";
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import PdfViewer from 'components/PdfViewer/PdfViewer';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);


const delimiteroptions = [
  { label: "Comma Seperated Value (,)", value: "," },
  { label: "Pipe Seperated Value (|)", value: "|" }
];


const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  }
}


// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `${k + offset}`,
    content: ` ${k + offset}`
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};


const ipynb2html = window.ipynb2html;
const trimFolderName = folderName => {
  folderName = folderName.slice(0, -1);
  return folderName.split('/').pop()
};

const trimFileName = fileName => {
  if (fileName !== null && fileName !== undefined) {
    return fileName.split('/').pop()
  }
};

const StorageBody = props => {
  let items = [];

  const {
    isSideSplited,
    splitscreen,
    folders,
    files,
    emptyRows,
    showFilesModal,
    loadmoreFlag,
    nextPageToken,
    viewSelected,
    myHomeFolders,
    sourceStorageId,
    sourceRootFolder,
    configArray

  } = props;

  const [isShowContext, setShowContext] = useState(false)

  const [showRenameModal, setshowRenameModal] = useState(false)

  const [renameToBeCreate, setrenameToBeCreate] = useState("")


  const showContext = () => setShowContext(true)
  const hideContext = () => setShowContext(false)

  const [isGetExtract, setExtractAction] = useState(false)

  const showExtract = () => setExtractAction(true)
  const hideExtract = () => setExtractAction(false)

  const [contextMargin, setContextMargin] = useState(null)
  const setContextMenuMargin = (margin) => setContextMargin(margin)

  const [selectedFiles, setSelectedFiles] = useState([])
  const [selectedFolders, setSelectedFolders] = useState([])

  const [fileSize, setfileSize] = useState([])


 const [folderstat,setfolderstatus] = useState('none')
  const setfoldertrue = (itemName) => setfolderstatus(itemName)
  const setfolderfalse = () => setfolderstatus('none')

  const [isFileAction, setFileAction] = useState(false)
  const enableDisableViewDownload = () => {
    if (selectedFolders.length === 0 && selectedFiles.length === 1) {
      setFileAction(true)
    } else {
      setFileAction(false)
    }
  }
  const [isAllFolders, setAllFolders] = useState(false)
  const showpopupFolders = () => setAllFolders(true)

  const deselectAll = () => {
    let classNameOfSelectedItem;
    let classNameToBeAdd;
    if (viewSelected === 1) {
      classNameOfSelectedItem = 'storage-item-select'
      classNameToBeAdd = 'py-2 storage-item row folderitem'
    } else {
      classNameOfSelectedItem = 'card-item-select'
      classNameToBeAdd = 'card-item card'
    }
    const elems = [].slice.call(document.getElementsByClassName(classNameOfSelectedItem))
    for (const elem of elems) {
      elem.dataset.select = false
      elem.className = classNameToBeAdd
    }
    setSelectedFolders([])
    setSelectedFiles([])
  }

  const onFolderClick = (event, folderName) => {
    let fname = folderName;
    if (props.itstrash === true) {
      fname = 'trash/' + fname;
    }
    event.stopPropagation()
    event.preventDefault()
    props.fetchStorageItems(fname, deselectAll, isSideSplited)
  }

  const openStorageView = (name, fileSize,event) => {
    event.preventDefault()
    let storageInfo = '';
    if (props.storageDetail !== null) {
      let storageDetail = props.storageDetail
      storageInfo = '&storageName=' + storageDetail.name + '&platformDefault=' + storageDetail.platformDefault + '&filesize=' + fileSize;
    }
    let newUrl;
    let currentUrl = window.location.href;
    newUrl = currentUrl.split("?path=");
    let reg = "/storage";
    let sId  = sourceStorageId === null ? "" : sourceStorageId;
    let root  = sourceRootFolder === null ? "" : sourceRootFolder;
    let replaceUrl = "/storageView?storage=" + sId + "&root=" + root + "&file=" + name + '&filesize=' + fileSize;
    if (storageInfo !== '') {
      replaceUrl += storageInfo;
    }
    let redirectUrl = newUrl[0].replace(reg, replaceUrl);
    window.open(redirectUrl, "_blank");
  }

  const previewFile = (name, event) => {
    event.preventDefault()
    let sendpath = "file"
    props.previewFile(name, sendpath, sourceStorageId, sourceRootFolder)
  }

  const downloadFile = (name, event) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let myPath = localStorage.getItem("filePathStorage");
    let sName = sourceStorageId === null ? "" : sourceStorageId;
    let root = sourceRootFolder === null ? "" : sourceRootFolder;
    StorageService.downloadObjectUrl(myPath, sName, root)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  const copyAlert = () => {
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied</b></i>);
  }

  const GetLink = (name, event) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let newUrl;
    let currentUrl = window.location.href;
    newUrl = currentUrl.split("?path=");
    let reg = "/storage";
    let sName = sourceStorageId === null ? "" : sourceStorageId;
    let root = sourceRootFolder === null ? "" : sourceRootFolder;
    let redirectUrl = newUrl[0].replace(reg, "/storageView?storage=" + sName + "&root=" + root + "&file=" + name);
    TinyURL.shorten(redirectUrl).then((res) => {
      var tempInput = document.createElement("input");
      tempInput.value = res;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      copyAlert()
      // ShareURL(res, name);
    })
  }

  const GetExtract = (name, event) => {
    event.preventDefault()
    let isDirectory = !isFileAction
    let destifolder = props.currFolder;
    if (destifolder === null) {
      destifolder = "/"
    }
    let extractdata = {
      "destinationPath": destifolder,
      "destinationStorage": {
        "rootFolder": sourceRootFolder,
        "storageId": sourceStorageId
      },
      "paths": [
        {
          "isDir": isDirectory,
          "sourcePath": name

        }
      ],
      "sourceStorage": {
        "rootFolder": sourceRootFolder,
        "storageId": sourceStorageId
      }
    }
    FileJobsService.ExtractFile(extractdata)
      .then((response) => {
      });
  }



  const addItemToSelected = (itemType, itemName) => {
    if (itemType === 'file') {
      const _selectedFiles = selectedFiles
      if (_selectedFiles.indexOf(itemName) === -1) {
        _selectedFiles.push(itemName)
        setSelectedFiles(_selectedFiles)
      }
    } else if (itemType === 'folder') {
      const _selectedFolders = selectedFolders
      if (_selectedFolders.indexOf(itemName) === -1) {
        _selectedFolders.push(itemName)
        setSelectedFolders(_selectedFolders)
      }
    }
  }


  const onRowClick = (event, itemType, itemName) => {
    event.preventDefault()
    const target = event.currentTarget
    let foldpath = itemType;
    if (itemType !== "folder" && itemType !== "file") {
      props.previewFile(itemName, foldpath, sourceStorageId, sourceRootFolder)
    }

    if ((target.dataset.id === trimFileName(itemName)) || (target.dataset.id === trimFolderName(itemName))) {
      target.dataset.select = true
      target.className = "py-2 storage-item folderitem row selectedrow"
    }
    else {
      target.dataset.select = false
      target.className = "py-2 storage-item row folderitem"
    }
  }

 const onItemRightClick = (event, itemType, itemName, filesize) => {
   if(itemName !== "emptyfolder"){
    const getextnzip = trimFileName(itemName).substr(trimFileName(itemName).lastIndexOf('.') + 1);
    if((getextnzip === "zip") || (getextnzip === "tar") || (getextnzip === "rar") || (getextnzip === "gz")){
        showExtract()
      }
      else {
        hideExtract()
      }
    }
    event.preventDefault()
    const target = event.currentTarget
    if (target.dataset.select === "false") {
      if (viewSelected === 1) {
        target.className = "py-2 storage-item storage-item-select row folderitem"
        target.dataset.imgselect = true
        if ((target.dataset.id === trimFileName(itemName)) || (target.dataset.id === trimFolderName(itemName))) {
          target.dataset.select = true
          setfoldertrue(itemName)
        }
        else {
          setfolderfalse()
        }
      } else {
        target.className = "card-item card-item-select card"

      }
    }

    setSelectedFiles([])
    setfileSize(filesize)
    setSelectedFolders([])
    addItemToSelected(itemType, itemName)

    /*
    * End Temprorly add this for single item selection
    */

    const boundTarget = target.getBoundingClientRect()

    var boundParent;
    switch (true) {
      // list view for folder
      case (viewSelected === 1 && itemType === "folder"):
        boundParent = target.parentElement.parentElement.parentElement.getBoundingClientRect();
        break;
      // list view for file
      case (viewSelected === 1 && itemType === "file"):
        boundParent = target.parentElement.parentElement.getBoundingClientRect()
        break;
      // grid view for folder and file
      case (viewSelected === 2 && itemType === "folder") || (viewSelected === 2 && itemType === "file"):
        boundParent = target.parentElement.parentElement.parentElement.parentElement.getBoundingClientRect()
        break;
      default:
        break;
    }

    const measureTop = event.clientY - (viewSelected === 1 ? boundParent.y : boundParent.y)
    const measureLeft = event.clientX - (viewSelected === 1 ? boundTarget.x : boundParent.x)
    let margin = {}

    if ((boundParent.width - measureLeft) > 200) {
      margin.marginLeft = measureLeft.toString() + "px"
    } else {
      margin.marginLeft = (boundParent.width - 200).toString() + "px"
    }

    if ((boundParent.height - measureTop) < 300) {
      margin.marginTop = (boundParent.height - 300).toString() + "px"
    } else {
      margin.marginTop = measureTop.toString() + "px"
    }
    setContextMenuMargin(margin)
    enableDisableViewDownload()
    showContext()
  }
  /* View File   */
  const onViewClick = (event) => {
    event.preventDefault()
    if(selectedFiles !== null && selectedFiles !== undefined && selectedFiles.length > 0){
          openStorageView(selectedFiles[0], fileSize, event)
    }
    hideContext()
    deselectAll()
  }
  /* Download File   */
  const onDownloadClick = (event) => {
    event.preventDefault()
    if(selectedFiles !== null && selectedFiles !== undefined && selectedFiles.length > 0){
      downloadFile(selectedFiles[0], event)
    }
    hideContext()
    deselectAll()
  }
  /* get Shareable link  */
  const onShareClick = (event) => {
    event.preventDefault()
    if(selectedFiles !== null && selectedFiles !== undefined && selectedFiles.length > 0){
      GetLink(selectedFiles[0], event)
    }
    hideContext()
    deselectAll()
  }
  /* Extract Folder */
  const onExtractClick = (event) => {
    event.preventDefault()
    GetExtract(selectedFiles[0], event)
    hideContext()
    deselectAll()
  }

  const toggleRenameModal = () => {
    if (showRenameModal) {
      setshowRenameModal(false)
    } else {
      setshowRenameModal(true)
    }
    hideContext()
    deselectAll()
  }

  const handleRenameChange = (event) => {
    setrenameToBeCreate(event.target.value);
  }

  const renameUpdate = (event) => {
    event.preventDefault();
    if (renameToBeCreate === "" || renameToBeCreate === undefined) {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please enter name</b></i>);
    } else {
      toggleRenameModal();
      props.renameFile(renameToBeCreate);
    }
  }


  const popPathName = (path) => {
    var replacedPath = path.replace(/\/$/, '');
    var rename = replacedPath.split('/').pop();
    return rename;
  }

  /*  rename file/folder  */
  const onRenameClick = (event) => {
    event.preventDefault()
    let name = isFileAction ? selectedFiles[0] : selectedFolders[0]
    let isDirectory = !isFileAction
    props.selectMoveFile(name, "Move", isDirectory)
    let renamewats = popPathName(name)
    setrenameToBeCreate(renamewats);
    toggleRenameModal();
    hideContext()
    deselectAll()
  }


  /* Move file/folder  */
  const onMoveClick = (event) => {
    event.preventDefault()
    let name = isFileAction ? selectedFiles[0] : selectedFolders[0]
    let isDirectory = !isFileAction
    let movewats = name
    let ShowFold = "true"
    showpopupFolders()

    if (splitscreen === false) {
      props.toggleShowFiles(ShowFold, movewats, "Move", isDirectory)
    }
    else {
      props.selectMoveFile(movewats, "Move", isDirectory)
    }
    hideContext()
    deselectAll()
  }
  /*  Paste file/folder  */
  const onPasteClick = (event) => {
    let name = selectedFolders[0]
    let isDirectory = !isFileAction
    let pastedetails = name
    props.pasteFolder(isSideSplited, pastedetails, isDirectory)
    hideContext()
    deselectAll()
  }
  /*  Copy file/folder  */
  const onCopyClick = (event) => {
    event.preventDefault()
    let name = isFileAction ? selectedFiles[0] : selectedFolders[0]
    let isDirectory = !isFileAction
    let copywats = name
    let ShowFold = "true"
    showpopupFolders()
    if (splitscreen === false) {
      props.toggleShowFiles(ShowFold, copywats, "Copy", isDirectory)
    }
    else {
      props.selectCopyFile(copywats, "Copy", isDirectory)
    }
    hideContext()
    deselectAll()
  }

  /* copy file path */
  const onCopyPathClick = (event) => {
    event.preventDefault()
    if (configArray !== undefined && configArray !== null && configArray.length > 0) {
      let filterArray = configArray.filter(item => item.id === sourceStorageId);
      let copyText = "";
      let prefixPath = "";
      if (filterArray.length > 0) {
        let sName = filterArray[0].name;
        let platfromDefault = filterArray[0].platformDefault;
        if (platfromDefault) {
          prefixPath = STORAGE_DEFAULT_MOUNT_PATH;
        }
        else {
          prefixPath = STORAGE_EXTERNAL_MOUNT_PATH + sName + "/" + sourceRootFolder + "/";
        }

          if (selectedFolders[0] !== undefined) {
            copyText = selectedFolders[0]
          }
          if (selectedFiles[0] !== undefined) {
            copyText = selectedFiles[0]
          }
        if (copyText !== undefined) {
          var filepath = document.createElement('textarea')
          filepath.innerText = prefixPath + copyText
          document.body.appendChild(filepath)
          filepath.select()
          document.execCommand('copy')
          filepath.remove()
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied</b></i>);
        }
      }
    }
    hideContext()
    deselectAll()
  }

  /*  Delete/Trash file/folder  */
  const onDeleteClick = (event, deleteevent) => {
    event.preventDefault()
    let name = isFileAction ? selectedFiles[0] : selectedFolders[0]
    let isDirectory = !isFileAction
    const title = isFileAction ? 'Delete File' : 'Delete Folder'
    const message = (
      isFileAction
        ? 'Are you sure to delete this file -' + trimFileName(name) + '?'
        : 'Are you sure to delete this folder -' + trimFolderName(name) + '?'
    )
    confirmAlert({
      title: title,
      message: message,
      buttons: [
        {
          label: 'Yes',
          onClick: e => {
            let destifolder = "";
            let sourcefolder = name;
            let movetotrashdata = {
              "destinationPath": destifolder,
              "paths": [
                {
                  "isDir": isDirectory,
                  "sourcePath": sourcefolder

                }
              ],
              "sourceStorage": {
                "rootFolder": sourceRootFolder,
                "storageId": sourceStorageId
              }
            }
            /*  Move to Trash */
           if(deleteevent === "Trash"){
            FileJobsService.TrashFolder(movetotrashdata)
            .then((response) => {
            props.fetchProgress(response.jobState,response.message,isSideSplited) 
            props.fetchStorageItems(props.currFolder, null, isSideSplited)
            });
           }
          /*  Delete From Trash */
          if(deleteevent === "Delete"){
            let sourcefolder = name;
            let deletedata  = {
              "destinationPath":destifolder,
              "paths": [
                {
                  "isDir": isDirectory,
                  "sourcePath": sourcefolder

                }
              ],
              "sourceStorage": {
                "rootFolder": sourceRootFolder,
                "storageId": sourceStorageId
              }
            }
            if(sourceStorageId === null){
              delete deletedata["sourceStorage"]
            }
            FileJobsService.DeleteFolder(deletedata)
            .then((response) => {
            props.fetchProgress(response.jobState,response.message,isSideSplited) 
            props.fetchStorageItems(props.currFolder, null, isSideSplited)
            });
           } 
          }
        },
        {
          label: 'No',
          onClick: () => {
          }
        }
      ]
    })
    hideContext()
    deselectAll()
  }
  
  /* Restore file/folder  */
  const onRestoreClick = (event) => {
    event.preventDefault()
    let name = isFileAction ? selectedFiles[0] : selectedFolders[0]
    let isDirectory = !isFileAction
    const title = isFileAction ? 'Restore File' : 'Restore Folder'
    const message = (
      isFileAction
        ? 'Are you sure to restore this file -' + trimFileName(name) + '?'
        : 'Are you sure to restore this folder -' + trimFolderName(name) + '?'
    )
    confirmAlert({
      title: title,
      message: message,
      buttons: [
        {
          label: 'Yes',
          onClick: e => {
            let destifolder = "";
            let sourcefolder = name;
            let restoredata = {
              "destinationPath": destifolder,
              "paths": [
                {
                  "isDir": isDirectory,
                  "sourcePath": sourcefolder

                }
              ],
              "sourceStorage": {
                "rootFolder": sourceRootFolder,
                "storageId": sourceStorageId
              }
            }
            if (sourceStorageId === null) {
              delete restoredata["sourceStorage"]
            }
            FileJobsService.RestoreFile(restoredata)
              .then((response) => {
                props.fetchProgress(response.jobState, response.message, isSideSplited)
                props.fetchStorageItems(props.currFolder, null, isSideSplited)

              })

          }
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    })
    hideContext()
    deselectAll()
  }

  const mouseDownEvent = (event) => {
    if (event.target.dataset.type !== 'context' && isShowContext) {
      hideContext()
      deselectAll()
    }
  }
  useEffect(() => {
    document.addEventListener("mousedown", mouseDownEvent)
    return () => {
      document.removeEventListener("mousedown", mouseDownEvent)
    }
  }, [isShowContext])


  // Display all folders
  for (const folder of folders) {
    const folderName = trimFolderName(folder)
    if (viewSelected === 1) {
      items.push(
        <div key={uuidv4()}>
          <Row
            tag="a"
            className="py-2 storage-item folderitem"
            data-select="false"
            data-id={folderName}
            onClick={e => {
              onRowClick(e, 'folder', folder); onFolderClick(e, folder);
            }}
            onContextMenu={e => { onItemRightClick(e, 'folder', folder) }}
          >
            <Col md="7" xs="7" className="storagetxt">
              <span
                className="folder"
                data-type="folder"
                data-name={folder}
                onClick={e => { onFolderClick(e, folder); }}
              >
                {folderstat === folder &&
                  <img src={cloading} data-imgselect="false" className="cloading" alt=""></img>
                }
                &nbsp; <i className="fas fa-folder mr-3 strgicontbl"></i>{folderName}

              </span>
            </Col>
            <Col md="2" xs="2" className="storagetxt">--</Col>
            <Col md="3" xs="3" className="storagetxt">--</Col>
          </Row>
        </div>
      )
    }
    else if (viewSelected === 2) {
      items.push(
        <Col sm={2}>
          <Card
            className="card-item"
            data-select="false"
            onClick={e => { onFolderClick(e, folder); }}
            onContextMenu={e => { onItemRightClick(e, 'folder', folder) }}
          >
            <CardBody>
              <i className="fas fa-folder fa-4x strgicon"
                onClick={e => {
                  props.previewFile(folderName,'folder',sourceStorageId, sourceRootFolder)
                }}
              ></i>
            </CardBody>
            <CardFooter className="card-item-name">
              <span
                className="storage-folder"
                data-type="folder"
                data-name={folder}
                onClick={e => { onFolderClick(e, folder) }}
                title={folderName}
              >
                {folderName}
              </span>
            </CardFooter>
          </Card>
        </Col>
      )
    }
  }
  // Display all files
  for (const file of files) {
    const fileName = trimFileName(file.name)
    if (viewSelected === 1) {
      items.push(
        <Row
          tag="a"
          key={uuidv4()}
          className="py-2 storage-item folderitem"
          data-select="false"
          data-id={fileName}
          onContextMenu={e => {onItemRightClick(e, 'file', file.name, file.size)}}

          onClick={e => {
            e.stopPropagation()
            previewFile(file.name, e);
            onRowClick(e, 'file', file.name)
          }}
        >
          <Col md="7" xs="7" className="storagetxt">
            <span id={fileName}
              className="storage-file"
              onClick={e => {
                e.stopPropagation()
                previewFile(file.name, e)
              }}
            >
              {folderstat === file.name &&
                <img src={cloading} data-imgselect="false" className="cloading" alt=""></img>
              }
              &nbsp; <img src={findIcon(imageFileExtension(file.content_type))} alt=""></img> &nbsp;
              {fileName}
            </span>
          </Col>
          <Col md="2" xs="2" className="storagetxt">{fileSizeSI(file.size)}</Col>
          <Col md="3" xs="3" className="storagetxt">{Moment(file.created).format('MMMM Do, YYYY hh:mma')}</Col>
        </Row>
      )
    }
    else if (viewSelected === 2) {
      items.push(
        <Col sm={2}>
          <Card
            className="card-item"
            data-select="false"
            onContextMenu={e => {onItemRightClick(e, 'file', file.name, file.size)}}

            onClick={e => {
              e.stopPropagation()
              previewFile(file.name, e)
            }}
          >
            <CardBody>
            &nbsp; <img src={findIcon(imageFileExtension(file.content_type))} style={{width: "42px"}} alt=""></img> &nbsp;
            </CardBody>
            <CardFooter className="card-item-name">
              <span id={fileName}
                className="storage-file"
                onClick={e => {
                  e.stopPropagation()
                  previewFile(file.name, e)
                }}
                title={fileName}
              >
                {fileName}
              </span>
            </CardFooter>
          </Card>
        </Col>
      )
    }
  }
  // Display all Folders in Modal
  if (isAllFolders) {
    if (props.showAllFolders === true) {
      for (const myHomeFolder of myHomeFolders) {
        items.push(
          <Row
            tag="a"
            className="py-2 storage-item folderitem"
            data-select="false"
            data-id={trimFolderName(myHomeFolder)}
            onClick={e => {
              onRowClick(e, 'folder', myHomeFolder); onFolderClick(e, myHomeFolder);
            }}
            onContextMenu={e => { onItemRightClick(e, 'folder', myHomeFolder) }}
          >
            <Col md="7" xs="7" className="storagetxt">
              <span
                className="folder"
                data-type="folder"
                data-name={myHomeFolder}
                onClick={e => { onFolderClick(e, myHomeFolder); }}
              >
                {folderstat === myHomeFolder &&
                  <img src={cloading} data-imgselect="false" className="cloading" alt=""></img>
                }
                &nbsp;         <i className="fas fa-folder mr-3 strgicontbl"></i>{trimFolderName(myHomeFolder)}
              </span>
            </Col>
            <Col md="2" xs="2" className="storagetxt"></Col>
            <Col md="3" xs="3" className="storagetxt"></Col>
          </Row>
        )

      }
    }
  }
  if (emptyRows === true) {
    items.push(
      <>
        <Row
          tag="a"
          className=""
          key={uuidv4()}
          style={{ minHeight: '20px', color: 'white' }}
          onContextMenu={e => { onItemRightClick(e, 'folder', 'emptyfolder') }}
        >
          <span className="folder">. </span>
          <Col md="7" xs="7" className="">

          </Col>
          <Col md="2" xs="2" className="storagetxt"></Col>
          <Col md="3" xs="3" className="storagetxt"></Col>
        </Row>
        <Row>
          <Col style={{ textAlign: "center" }}>
            {nextPageToken !== null && loadmoreFlag && <ButtonGroup className="chatLoading" style={{ verticalAlign: 'sub' }}>
              <Badge color="info"> Loading... </Badge>
            </ButtonGroup>}
          </Col>
        </Row>
      </>
    )
  }

if (emptyRows === true) {
  items.push(
    <>
     <Row
      tag="a"
      className=""
      key={uuidv4()} 
      style={{minHeight: '20px',color: 'white'}}
      onContextMenu={e => {onItemRightClick(e, 'folder', 'emptyfolder')}}
    >
      <span className="folder">. </span>
      <Col md="7" xs="7" className="">
       
        </Col>
        <Col md="2" xs="2" className="storagetxt"></Col>
        <Col md="3" xs="3" className="storagetxt"></Col>
  </Row>
      <Row>
      <Col className="textcenter">
      {nextPageToken !== null && loadmoreFlag && <ButtonGroup className="chatLoading" style={{verticalAlign:'sub'}}>
        <Badge color="info"> Loading... </Badge>
      </ButtonGroup>}
      </Col>
    </Row>
  </>
  )}
  let itemsView;
  if (viewSelected === 2) {
    itemsView = <Row>{items}</Row>
  } else {
    itemsView = items
  }

  return (
    <div>

      {isShowContext &&
        <Row>
          <Col
            md="auto"
            id="context-menu"
            className="storage-context"
            style={contextMargin}
          >
            <ListGroup flush>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a" data-type='context'
                onClick={onViewClick}
              >
                <i className="fas fa-binoculars mr-3" />View
              </ListGroupItem>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a" data-type='context'
                onClick={onDownloadClick}
              >
                <i className="fas fa-download mr-3" />Download
              </ListGroupItem>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a"
                data-type='context'
                onClick={onShareClick}>
                <i className="fas fa-link mr-3"></i>Get Sharable Link
              </ListGroupItem>
            </ListGroup>

            {isFileAction && <hr />}
            <ListGroup flush>

              {props.itstrash &&
                <ListGroup flush>
                  <ListGroupItem
                    // disabled={!isFileAction}
                    tag="a" data-type='context'
                    onClick={e => { onDeleteClick(e, 'Delete') }}
                  >
                    <i className="fas fa-trash-alt mr-3" />Delete
                  </ListGroupItem>
                  <ListGroupItem
                    // disabled={!isFileAction}
                    tag="a" data-type='context'
                    onClick={e => { onRestoreClick(e) }}
                  >
                    <i className="fas fa-trash-restore mr-3" />Restore
                  </ListGroupItem>
                </ListGroup>

              }

              {!props.itstrash &&
                <ListGroup flush>
                  <ListGroupItem disabled tag="a" data-type='context'>
                    <i className="fas fa-copy mr-3" />Duplicate
                  </ListGroupItem>
                  {!showFilesModal && <><ListGroupItem tag="a" data-type='context' onClick={e => { onMoveClick(e) }}>
                    <i className="fas fa-file-export mr-3" />Move
                  </ListGroupItem>
                    <ListGroupItem tag="a" data-type='context' onClick={e => { onCopyClick(e) }}>
                      <i className="fas fa-copy mr-3" />Copy
                    </ListGroupItem>
                    <ListGroupItem tag="a" data-type='context' onClick={e => { onRenameClick(e) }}>
                      <i className="fas fa-edit mr-3" />Rename
                    </ListGroupItem>
                    <ListGroupItem tag="a" data-type='context' onClick={e => { onCopyPathClick(e) }}>
                      <i className="fas fa-copy mr-3" />Copy Path
                    </ListGroupItem></>}
                  <ListGroupItem // disabled={!isFileAction} 
                    tag="a" data-type='context' onClick={e => { onDeleteClick(e, 'Trash') }}>
                    <i className="fas fa-trash-alt mr-3" />Move to trash
                  </ListGroupItem>
                  {isGetExtract &&
                    <ListGroupItem
                      disabled={!isFileAction}
                      tag="a" data-type='context'
                      onClick={onExtractClick}
                    >
                      <i className="fas fa-box-open mr-3" />Extract
                    </ListGroupItem>
                  }
                </ListGroup>
              }
              <ListGroupItem
                disabled={!splitscreen || isFileAction}
                tag="a" data-type='context'
                onClick={e => { onPasteClick(e) }}>
                <i className="fas fa-paste mr-3" />Paste
              </ListGroupItem>


              <ListGroupItem disabled tag="a" data-type='context'>
                <i className="fas fa-file mr-3" />Rename
              </ListGroupItem>
              <hr />
              <ListGroupItem style={{ backgroundColor: '#eee', cursor: 'pointer' }} data-type='context'>
                <i className="fas fa-info-circle mr-3" />Permission
              </ListGroupItem>

            </ListGroup>
          </Col>
        </Row>
      }
      {itemsView}
      <Modal
        centered
        className="rename-modal"
        isOpen={showRenameModal}
        toggle={toggleRenameModal}
        backdrop="static"
        returnFocusAfterClose={false}>
        <ModalHeader toggle={toggleRenameModal}>Rename</ModalHeader>
        <ModalBody>
          <Input
            placeholder="Folder Name"
            name="folderToBeCreate"
            className="inputRename"
            value={renameToBeCreate}
            onChange={handleRenameChange}
          />
          <Row>
            <Col sm={12} lg={12} xl={8} className="renamepopHint">
              <span className="notepopHint">Note: </span><span> Update reference of 'Renamed' folder/file in Project</span>
            </Col>
            <Col sm={12} lg={12} xl={4}>
              <Button
                size="sm"
                color="primary"
                className="storage-folder-btn renameBtn"
                onClick={e => renameUpdate(e)}>
                Ok
              </Button>
            </Col>
          </Row>

        </ModalBody>
      </Modal>
    </div>
  )
    }

class Storageui extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      folders: [],
      files: [],
      emptyRows: true,
      preFolder: null,
      currFolder: null,
      nextFolder: null,
      nextPageToken: null,
      progressmsg: "",
      navigations: [],
      foldersSide: [],
      filesSide: [],
      preFolderSide: null,
      currFolderSide: null,
      nextFolderSide: null,
      nextPageTokenSide: null,
      navigationsSide: [],
      popoverOpenFolderCreate: false,
      popoverOpenFolderCreateSplit: false,
      folderToBeCreate: null,
      folderUploadFiles: null,
      viewSelected: 1,
      myHomeFolders: [],
      myHomeFoldersOpen: true,
      statemsg: "",
      dispayload: "none",
      myfilename: "",
      showPreview: false,
      showSplit: false,
      myContent: '',
      myContentChart: '',
      fileName: '',
      onlyfilename: 'Home',
      fileType: '',
      renderNotebook: '',
      myContents: [],
      DownloadUrl: '',
      delimiter: ',',
      delimiterName: ',',
      searchKey: "",
      FilterFilesData: [],
      FilterFolderData: [],
      itstrash: false,
      showAllFolders: false,
      sourceFolder: '',
      sourcemove: '',
      destinationmove: '',
      sourcecopy: '',
      destinationcopy: '',
      fileSize: "",
      showbutton: "",
      jsonData: false,
      secondsplit: false,
      pastefrom: "",
      currentnavi: "",
      emptyfolder: "",
      emptyhome: false,
      isitDir: "",
      items: getItems(10),
      selected: getItems(5, 10),
      totalPages: 0,
      activePage: 1,
      totalRecords: 0,
      renameChanged: "",
      showStorageConfig: false,
      CloudBucketList: [],
      SelectedBucketList: [],
      SelectAllFlag: false,
      name: "",
      description: "",
      provisionerNames: [],
      provisionerId: "",
      provisionerType: "GOOGLE",
      isStoragePrimary: false,
      isStorageStatus: true,
      configArray: [],
      mouseHoverStorageName: "",
      activeConfigPath: "",
      editId: "",
      showStorageBucketList: false,
      openedCollapses: [""],
      sourceStorageId: null,
      sourceRootFolder: null,
      sourceStorageIdSide: null,
      sourceRootFolderSide: null,
      destinationStorageId: null,
      destinationRootFolder: null,
      userRole: "",
      showConfirmationCopyMove: false,
      dataAction: {},
      modeTransfer: "",
      showCopyMoveActionModal: false,
      loadmoreFlag: false,
      showFilesModal: false,
      renameNewValue: "",
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      selectedStorage: "",
      showTasksPanel: false,
      pendingDTOS: [],
      totalPagesPending: 0,
      currentPageNumber: 0,
      hotSettings: [],
      readonlyTable: true,
      NoData: false,
      showHandsontable: false,
      showPdfViewer:false,
      numPages: null,
      pdfPageNumber: 1,
      pdfContent:"",
      file: "",
      sheetName:[],
      keyValue:[],
      xlsxurl:''
      }
      this.hotformula = {
        formulas: {
          engine: HyperFormula,
        },
        afterChange: function (r, c) {
          var data = this.getData();
        }
      }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.folderUploadRef = React.createRef()
    this.splitFolderUploadRef = React.createRef()
    this.filePond = React.createRef()
    this.hotTableComponent = React.createRef();
  }

  collapsesToggle = collapse => {
    let openedCollapses = this.state.openedCollapses;

    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: []
      });
    } else {
      this.setState({
        openedCollapses: [collapse]
      });
    }

  };

  id2List = {
    droppable: 'items',
    droppable2: 'selected'
  };

  getList = id => this.state[this.id2List[id]];

  onDragEnd = result => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const items = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );

      let state = { items };

      if (source.droppableId === 'droppable2') {
        state = { selected: items };
      }

      this.setState(state);
    } else {
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );

      this.setState({
        items: result.droppable,
        selected: result.droppable2
      });
    }
  };

  componentDidMount = () => {
    this.setState({
      userRole: localStorage.getItem("role")
    })
    localStorage.removeItem("sharefilelink")
    localStorage.removeItem("filePathStorage")
    this.GetAllStorageConfig();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("ws-message-storage", this.eventListerForStorage);
    window.addEventListener("ws-message-storage", this.eventListerForStorage);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("ws-message-storage", this.eventListerForStorage);
  }
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }
  AddNewStorageBtnClick = () => {
    this.getProvisionerServices();
    this.toggleStorageConfig();
  }
  eventListerForStorage = (event) => {
    if (event !== undefined) {
      let noteData = event.detail.data;
      if (noteData !== undefined) {
        storagejobStatusAlert(noteData);
        this.fetchStorageItems(this.state.currFolder, null, false)
        this.fetchStorageItems(this.state.currFolderSide, null, true)
      }
    }
  }
  onBucketNameCickEvent = (item, bucketData) => {
    this.setState({
      sourceStorageId: item.id,
      sourceRootFolder: bucketData !== null ? bucketData.bucketName : null,
      provisionerType: item.provisionerType,
      activeConfigPath: item.id,
      selectedStorage: bucketData !== null ? bucketData.bucketName : ""
    }, () => {
      this.fetchStorageItems("", null, false);
    })
  }
  onBucketNameClick_Popup = (item, bucketData) => {
    this.setState({
      destinationStorageId: item.id,
      destinationRootFolder: bucketData.bucketName,
      provisionerType: item.provisionerType,
      activeConfigPath: item.id,
      selectedStorage: bucketData.bucketName,
    }, () => {
      this.fetchStorageItems("", null, false);
    })
  }
  OpenConfigureBucketes = () => {
    if (this.state.provisionerId === "" || this.state.provisionerId === undefined || this.state.provisionerId === null) {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please Select Provisioner</b></i>);
    } else {
      this.toggleStorageBucketList();
    }
  }
  GetAllStorageConfig = () => {
    StorageConfigService.getAllStorageConfig()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let configData = [];
          this.setState({
            configArray: []
          }, () => {
            configData = response.storageDTOPage.content
            this.configArrayModified(configData);
          })
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      }
      );
  }
  getPlatformDefaultConfig = (data) => {
    let platformDefault = data.filter(item => item.platformDefault);
    if (platformDefault.length > 0) {
      return platformDefault[0];
    }
  }
  getStorageDetail = (storageId) => {
    let storageDetails = this.state.configArray.filter(item => item.id === storageId)
    if (storageDetails.length > 0) {
      return storageDetails[0]
    }
    return null
  }
  configArrayModified = (data) => {
    let platformDefault = this.getPlatformDefaultConfig(data);
    let activeStorage = '';
    if (platformDefault !== null && platformDefault !== undefined) {
      activeStorage = platformDefault.id;
      this.setState({ sourceStorageId: activeStorage })
    }
    this.setState({
      configArray: data,
      activeConfigPath: activeStorage,
    })
    const url = window.location.href
    let strgpath = new URLSearchParams((url).substring(url.indexOf('?') + 1)).get('path')
    if (strgpath !== null) {
      this.fetchStorageItems(strgpath, null, false)
    } else {
      this.fetchStorageItems(null, null, false)
    }
  }
  getStorageConfig = () => {
    let value = this.state.configArray;
    return value;
  }
  onStorageConfigDeleteConfirmation = (e, id, name) => {
    e.preventDefault();
    confirmAlert({
      title: 'Remove Storage',
      message: 'Are you sure to remove this configuration -' + name + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.RemoveStorageConfig(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }
  // Handling remove job actions
  RemoveStorageConfig = (rid) => {
    StorageConfigService.deleteStorageConfig(rid)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          this.GetAllStorageConfig(); // Reload config data
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      });
  }
  onStorageConfigEdit = (e, id) => {
    // e.preventDefault();
    this.setState({
      editId: id
    })
    this.getProvisionerServices();
    StorageConfigService.getAllStorageConfigById(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.storageDTOS.length > 0) {
            let configData = [];
            configData = response.storageDTOS
            this.setState({
              name: configData[0].name,
              description: configData[0].description,
              provisionerId: configData[0].provisionerId,
              provisionerType: configData[0].provisionerType,
              isStoragePrimary: configData[0].primary,
              isStorageStatus: configData[0].storageStatus === "ENABLED" ? true : false,
              SelectedBucketList: configData[0].storageConfig.bucketStorages,
            }, () => {
              this.toggleStorageConfig();
            })
          }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      }
      );
  }
  GetBucketsList = () => {
    StorageService.getBucketsList(this.state.provisionerId)
      .then((response) => {
        let temp = [];
        if (response.result.length > 0) {
          for (let bucket of response.result) {
            let item = {
              bucketName: bucket.name,
              chooseBucketFlag: false,
              primary: false,
              readOnly: false,
              dateCreated: bucket.created
            };
            temp.push(item)
          }
          this.setState({
            CloudBucketList: temp
          }, () => {
            if(this.state.SelectedBucketList.length > 0 && this.state.CloudBucketList.length > 0){
              this.state.SelectedBucketList.forEach(function (text) {
                let index = temp.findIndex(item => item.bucketName === text.bucketName);
                temp[index].chooseBucketFlag = true;
              });
              if (this.state.SelectedBucketList.length === this.state.CloudBucketList.length) {
                this.setState({
                  SelectAllFlag: true
                })
              } else {
                this.setState({
                  SelectAllFlag: false
                })
              }
            }
          });
        }
      }
      );
  }
  handleMouseHover = (item) => {
    if (item !== default_StorageName && this.state.userRole === "TENANT_ADMIN") {
      this.setState({
        mouseHoverStorageName: item
      })
    }
  }
  handleMouseLeave = (e) => {
    e.preventDefault()
  }
  handleScroll = (e) => {
    e.preventDefault()
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      let prefix = null
      let files = []
      let folders = []
      let pageToken = null
      let isSideSplited = false
      if (isSideSplited) {
        prefix = this.state.currFolderSide
        files = this.state.filesSide
        folders = this.state.foldersSide
        pageToken = this.state.nextPageTokenSide
      } else {
        prefix = this.state.currFolder
        files = this.state.files
        folders = this.state.folders
        pageToken = this.state.nextPageToken
        this.setState({
          FilterFilesData: [],
          FilterFolderData: [],
        })
      }
      if (pageToken) {
        this.setState({
          loadmoreFlag: true
        })
        this._fetchStorageItems(prefix, pageToken, files, folders, isSideSplited)
      } else {
        this.setState({
          loadmoreFlag: false
        })
      }
    }
  }
  handleSelect_CloudBucketList = idx => e => {
    const { name } = e.target;
    const CloudBucketList = [...this.state.CloudBucketList];
    CloudBucketList[idx] = {
      [name]: e.target.checked
    };
    if (name === "chooseBucketFlag") {
      CloudBucketList[idx].bucketName = this.state.CloudBucketList[idx].bucketName;
      CloudBucketList[idx].primary = this.state.CloudBucketList[idx].primary;
      CloudBucketList[idx].readOnly = this.state.CloudBucketList[idx].readOnly;
      CloudBucketList[idx].chooseBucketFlag = e.target.checked;
      CloudBucketList[idx].dateCreated = this.state.CloudBucketList[idx].dateCreated;
    }
    this.setState({
      CloudBucketList
    }, () => {
      let selectedBucket = this.state.CloudBucketList.filter(item => item.chooseBucketFlag === true);
      if (selectedBucket.length === this.state.CloudBucketList.length) {
        this.setState({
          SelectAllFlag: true
        })
      } else {
        this.setState({
          SelectAllFlag: false
        })
      }
    });
  };
  handleSelectAll_CloudBucketList = () => e => {
    const CloudBucketList = [...this.state.CloudBucketList];
    this.setState({
      SelectAllFlag: e.target.checked
    })
    for (var index = 0; index < this.state.CloudBucketList.length; index++) {
      CloudBucketList[index].bucketName = this.state.CloudBucketList[index].bucketName;
      CloudBucketList[index].chooseBucketFlag = e.target.checked;
      CloudBucketList[index].primary = false;
      CloudBucketList[index].readOnly = false;
    }

    this.setState({
      CloudBucketList
    });
  };
  handleChangeBucket = idx => e => {
    const { name, value } = e.target;
    const SelectedBucketList = [...this.state.SelectedBucketList];
    SelectedBucketList[idx] = {
      [name]: value
    };
    if (name === "primary") {
      for (var index = 0; index < this.state.SelectedBucketList.length; index++) {
        if (idx === index) {
          SelectedBucketList[index].bucketName = this.state.SelectedBucketList[index].bucketName;
          SelectedBucketList[index].primary = e.target.checked;
          SelectedBucketList[index].readOnly = this.state.SelectedBucketList[index].readOnly;
          SelectedBucketList[index].chooseBucketFlag = this.state.SelectedBucketList[index].chooseBucketFlag;
        } else {
          SelectedBucketList[index].bucketName = this.state.SelectedBucketList[index].bucketName;
          SelectedBucketList[index].primary = !e.target.checked;
          SelectedBucketList[index].readOnly = this.state.SelectedBucketList[index].readOnly;
          SelectedBucketList[index].chooseBucketFlag = this.state.SelectedBucketList[index].chooseBucketFlag;

        }
      }
    }
    if (name === "readOnly") {
      SelectedBucketList[idx].bucketName = this.state.SelectedBucketList[idx].bucketName;
      SelectedBucketList[idx].primary = this.state.SelectedBucketList[idx].primary;
      SelectedBucketList[idx].readOnly = e.target.checked;
      SelectedBucketList[idx].chooseBucketFlag = this.state.SelectedBucketList[idx].chooseBucketFlag;
    }

    this.setState({
      SelectedBucketList
    });
  };
  handleRemoveSpecificRow = (idx) => () => {
    const SelectedBucketList = [...this.state.SelectedBucketList]
    SelectedBucketList.splice(idx, 1)
    this.setState({ SelectedBucketList })
  }
  setErrorMessage(message) {
    if (message === "") {
      this.setState({
        errorMessage: message,
        errorSubmitted: false
      })
    } else {
      document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage: message,
        errorSubmitted: true
      });
    }
  }
  renameFile = (rename) => {
    this.setState({
      renameChanged: rename
    }, () => {
      try {
        let renamedata = {
          "isDir": this.state.isitDir,
          "newName": this.state.renameChanged,
          "sourcePath": this.state.sourcemove,
          "sourceStorage": {
            "rootFolder": this.state.sourceRootFolder,
            "storageId": this.state.sourceStorageId
          }
        }
        if (this.state.sourceStorageId === null) {
          delete renamedata["sourceStorage"]
        }
        FileJobsService.RenameFile(renamedata)
          .then((response) => {
          });
      } catch (err) {
      }
    })
  }
  handleChangeSelectDelimiter = (event) => {
    this.setState({
      myContent: this.state.myContent,
      delimiter: event.value
    });
    this.renderText(this.state.DownloadUrl)
  }
  handleChangeTypes = (event) => {
    this.setState({
      provisionerType: event.label,
      provisionerId: event.value,
      SelectedBucketList : [],
      CloudBucketList : []
    })

  }
  handleSwitch(elem, state) {
    this.setState({ isStoragePrimary: state })
  }
  handleSwitchStorageStaus(elem, state) {
    this.setState({ isStorageStatus: state })
  }
  /* To get Input Text */
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  setViewSelected = (selected) => {
    this.setState({ viewSelected: selected })
  }
  // Download particular file in input or code
  downloadparticularFiles = (fileName, storageId, rootFolder) => {
    StorageService.downloadObjectUrl(fileName, storageId, rootFolder)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }
  setCurrPreFolder = (prefix, isSideSplited) => {
    let actualCurrFolder = null
    let actualPreFolder = null
    if (!isSideSplited) {
      actualCurrFolder = 'currFolder'
      actualPreFolder = 'preFolder'
    } else {
      actualCurrFolder = 'currFolderSide'
      actualPreFolder = 'preFolderSide'

    }
     if (prefix) {
      this.setState({ [actualCurrFolder]: prefix,  myfilename : prefix.replace('/', ' ')})
      if (isSideSplited === false) {
        let cf = [actualCurrFolder] = prefix
        this.setState({ emptyfolder: cf })
      }
      if (isSideSplited === true) {
        let cf = [actualCurrFolder] = prefix
        this.setState({ emptyfolder: cf })
      }
      let preFolderArr = prefix.split('/').slice(0, -2)
      preFolderArr.push('')
      this.setState({ [actualPreFolder]: preFolderArr.join('/') })
    } else {
      this.setState({ [actualCurrFolder]: null, [actualPreFolder]: null })
    }
  }
  _fetchStorageItems_trash = (prefix, pageToken, files, folders, isSideSplited) => {
    this.setState({
      loading: "block",
    });
    let storageId = this.state.showFilesModal === true ? this.state.destinationStorageId : this.state.sourceStorageId;
    let rootFolder = this.state.showFilesModal === true ? this.state.destinationRootFolder : this.state.sourceRootFolder;
    this.setState({ itstrash: true });
    let trashpath = prefix
    let newtrash = trashpath.replace("trash/", "");
    trashpath = newtrash
    if (prefix !== undefined && prefix !== null) {
      StorageService.trashObject(trashpath, storageId, rootFolder, pageToken)
        .then((response) => {
          files = [...files, ...response.result]
          folders = [...folders, ...response.prefixes]

          if (response.next_page_token) {
            if (isSideSplited) {
              this.setState({ nextPageTokenSide: response.next_page_token })
            } else {
              this.setState({ nextPageToken: response.next_page_token })
            }
          } else {
            if (isSideSplited) {
              this.setState({ nextPageTokenSide: null })
            } else {
              this.setState({ nextPageToken: null })
            }
          }

          if (!prefix) {
            this.setState({ myHomeFolders: folders, itstrash: false })
          }
          if (this.state.showAllFolders === 'true') {
            this.setState({ myHomeFolders: folders })
          }
          this.setCurrPreFolder(prefix, isSideSplited)
          if (isSideSplited === false) {
            this.setState({ folders: folders, FilterFolderData: folders, loading: "none", secondsplit: "false" })
            this.setState({ files: files, FilterFilesData: files, loading: "none", secondsplit: "false" })
          }
          if (isSideSplited === true) {
            this.setState({ foldersSide: folders, FilterFolderData: folders, loading: "none", secondsplit: "true" })
            this.setState({ filesSide: files, FilterFilesData: files, loading: "none", secondsplit: "true" })
          }
          try {
            this.sortDesc('name', isSideSplited)
            this.constructNavigation(isSideSplited)
            document.getElementById('storage-label-name').innerHTML = 'Name'
            document.getElementById('storage-label-size').innerHTML = 'Size '
            document.getElementById('storage-label-created').innerHTML = 'Last Modified'
          } catch (err) {
          }
        })
    }
  }
  _fetchStorageItems = (prefix, pageToken, files, folders, isSideSplited) => {

    this.setState({
      loading: "block",
    });
    let storageId = this.state.showFilesModal === true ? this.state.destinationStorageId : this.state.sourceStorageId;
    let rootFolder = this.state.showFilesModal === true ? this.state.destinationRootFolder : this.state.sourceRootFolder;
    this.setState({viewpageToken : pageToken, viewprefix: prefix})
    StorageService.listObjects(prefix, storageId, rootFolder, pageToken)
      .then((response) => {
        files = [...files, ...response.result]
        folders = [...folders, ...response.prefixes]

        if (response.next_page_token) {
          if (isSideSplited) {
            this.setState({ nextPageTokenSide: response.next_page_token })
          } else {
            this.setState({ nextPageToken: response.next_page_token })
          }
        } else {
          if (isSideSplited) {
            this.setState({ nextPageTokenSide: null })
          } else {
            this.setState({ nextPageToken: null })
          }
        }

        if (!prefix) {
          this.setState({ myHomeFolders: folders, itstrash: false })
        }
        if (this.state.showAllFolders === 'true') {
          this.setState({ myHomeFolders: folders })
        }
        this.setCurrPreFolder(prefix, isSideSplited)
        if (isSideSplited === false) {
          this.setState({ folders: folders, FilterFolderData: folders, loading: "none", secondsplit: "false" })
          this.setState({ files: files, FilterFilesData: files, loading: "none", secondsplit: "false" })
        }
        if (isSideSplited === true) {
          this.setState({ foldersSide: folders, FilterFolderData: folders, loading: "none", secondsplit: "true" })
          this.setState({ filesSide: files, FilterFilesData: files, loading: "none", secondsplit: "true" })
        }
        try {
          this.sortDesc('name', isSideSplited)
          this.constructNavigation(isSideSplited)
          document.getElementById('storage-label-name').innerHTML = 'Name'
          document.getElementById('storage-label-size').innerHTML = 'Size '
          document.getElementById('storage-label-created').innerHTML = 'Last Modified'
        } catch (err) {
        }
      })
  }
  onChangeStorageSearch = (value) => {
    if (value === "") {
      this.setState({
        files: this.state.FilterFilesData,
        folders: this.state.FilterFolderData,
        searchKey: value
      })
    } else {
      const filteredfiles = this.state.FilterFilesData.filter(item => item.name.toString().toLowerCase().includes(value.toLowerCase()));
      const filteredFolder = this.state.FilterFolderData.filter(item => item.toString().toLowerCase().includes(value.toLowerCase()));
      this.setState({
        files: filteredfiles,
        folders: filteredFolder,
        searchKey: value
      })
    }
  }
  /* Get Trash files when click from side icon */
  getTrashFile = () => {
    this.fetchStorageItems('trash/', null, false)
  }
  fetchStorageItems = (prefix, deselectAll, isSideSplited) => {
    if (deselectAll) {
      deselectAll()
    }
    if (isSideSplited === true) {
      this.setState({
        filesSide: [],
        foldersSide: [],
        nextPageTokenSide: null
      })
    }
    else {
      this.setState({
        files: [],
        folders: [],
        nextPageToken: null,
        FilterFilesData: [],
        FilterFolderData: [],
      })
    }

    if (prefix === null || prefix === "" || prefix === undefined) {
      this._fetchStorageItems(prefix, null, [], [], isSideSplited)
    } else {
      if (prefix.includes("trash/") || this.state.itstrash) {
        this._fetchStorageItems_trash(prefix, null, [], [], isSideSplited)
      } else {
        this._fetchStorageItems(prefix, null, [], [], isSideSplited)
      }
    }
  }
  /* Get Trash files/folders inside trash */
  fetchStorageTrashItems = (trashpath, pageToken, files, folders, isSideSplited) => {
    let storageId = this.state.showFilesModal === true ? this.state.destinationStorageId : this.state.sourceStorageId;
    let rootFolder = this.state.showFilesModal === true ? this.state.destinationRootFolder : this.state.sourceRootFolder;
    StorageService.trashObject(trashpath, storageId, rootFolder)
      .then((response) => {
        files = [...files, ...response.result]
        folders = [...folders, ...response.prefixes]
        this.setState({ folders: folders, FilterFolderData: folders, loading: "none", secondsplit: "false" })
        this.setState({ files: files, FilterFilesData: files, loading: "none", secondsplit: "false" })
      }).catch((error) => {
      })
  }
  fetchProgress = (jobState, progressmsg, isSideSplited) => {
    let emptymsg = ""
   this.setState({statemsg: progressmsg,dispayload:"block"})
   setTimeout(() => {
    this.setState({statemsg: emptymsg,dispayload:"none"})
    if (isSideSplited === true) {
      this.fetchStorageItems(this.state.currFolderSide,null, true)
    }
      else{
        this.fetchStorageItems(this.state.currFolder,null, false)
      }
    }, 4000);

  }
  previewFile = (name, path, storageId, rootFolder) => {
    if (name !== null && name !== undefined) {
      let myPath = name
      let onlyfilename = trimFileName(name)
      let ext = myPath.substring(myPath.lastIndexOf(".") + 1)
      this.setState({
        fileName: myPath,
        fileType: ext,
        onlyfilename: onlyfilename,
        loading: "block"
      })
      if (path !== "folder" && (path === "file" && this.state.showPreview)) {
        StorageService.downloadObjectUrl(myPath, storageId, rootFolder)
          .then((response) => {
            this.renderText(response.download_url);
            this.setState({ loading: "none", DownloadUrl: response.download_url });
          }).catch((error) => {
            if (path === "folder") {
              this.setState({
                fileType: 'png',
                myContent: undefinedfile,
                fileName: name,
                onlyfilename: onlyfilename,
                loading: "none"
              })
            }
            else {
              this.setState({
                fileType: 'png',
                myContent: page404,
                fileName: 'File Not Found!!!',
                loading: "none"
              })
            }
            if (this.state.onlyfilename === '') {
              this.setState({ onlyfilename: 'Home' })
            }
          })
      } else {
        this.setState({
          myContent: undefinedfile,
          fileName: name,
          onlyfilename: onlyfilename,
          loading: "none",
          fileType: "png"
        })
      }
    }
  }
  renderText = (url) => {
    this.setState({
      loading: "block"
    })
    if (this.state.fileType === "jpeg" || this.state.fileType === "jpg" ||
      this.state.fileType === "png") {
      this.setState({
        myContent: url,
        loading: "none"
      })
    }
   else if (this.state.fileType === "pdf") {
      this.setState({
        myContent: url,
        pdfcontent: url,
        showPdfViewer:true,
        loading: "none"
      })
      this.state.myContent = url;
      this.state.pdfcontent = url;
    }
    else if (this.state.fileType === "xlsx" || this.state.fileType === "xls") {
      this.setState({sheetName:[]})
      var url = url;
      this.setState({xlsxurl: url})
     var req = new XMLHttpRequest();
     req.open("GET", url, true);
      var result  = [];
      req.responseType = "arraybuffer";     
      req.onload = (e) => {
      var data = new Uint8Array(req.response);
      var wb = XLSX.read(data, {type:"array"});
      const sheet = wb.Sheets;
      let filtervalues = "";
      this.setState({
      keyValue:sheet
      },()=>{
      filtervalues = Object.values(this.state.keyValue);
      })
      for (const[key, value] of Object.entries(sheet)) {
      const ws = wb.Sheets[key];
      let list = this.state.sheetName.push(key);
      const html = XLSX.utils.sheet_to_csv(filtervalues[0]);
      result = CSVToJSONs(html, ',');
      this.setState({
       hotSettings: result,
       loading: false,
       readonlyTable:false,
       activeExcel:this.state.sheetName[0]
      })
     }
  };  
     req.send();
   }
    else {
      axios.get(url)
        .then(response => {
          if (this.state.fileType === "ipynb") {
            let notebook = response.data
            if(response.data !== "" && response.data !== undefined){
            let element = ipynb2html.render(notebook).outerHTML;
            this.setState({
            myContent:element,
            loading:"none"
          })
        }
        else{
          this.setState({
            myContent:[],
            loading:"none"
          })
        }
        }else if(this.state.fileType === "csv"){
          this.setState({
            readonlyTable: true,
            contextMenuTable: true,
            loading: false
          })
          if (response.data !== null && response.data.length > 0) {
            let result = CSVToJSONs(response.data, this.state.delimiter);
            this.loadHandsonTable(result);
            this.setState({ showHandsontable: true })
          }
          else {
            this.setState({ NoDataText: "---- No Data Found ----", NoData: true })
          }        
          }else if((this.state.fileType === "zip") || (this.state.fileType === "tar") || (this.state.fileType === "rar") || (this.state.fileType === "gz") || (this.state.fileType === "exe")){     
            this.setState({
              fileType: "png",
              myContent: unknownfile,
              loading: "none"
            })
          }
          else {
            this.setState({
              fileType: "others",
              myContent: response.data.toString()
            })
          }
        });
    }
  }
  getTabData = (tabid) => {
    var result  = [];
    let filteredTabData = Object.fromEntries(Object.entries(this.state.keyValue).filter(([key]) => key.includes(tabid)));
    let filtervalues = Object.values(filteredTabData);
    for (const[key, value] of Object.entries(filtervalues[0])) {
      const html = XLSX.utils.sheet_to_csv(filtervalues[0]);
     result = CSVToJSONs(html, ',');
      this.setState({
       hotSettings: result,
       loading: false,
       activeExcel:tabid
      })
     }
}
  loadHandsonTable = (jsonCsv) => {
    this.setState({ hotSettings: jsonCsv })
  }
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages: numPages })
  };
  goToPrevPage = () => {
    this.setState({ pdfPageNumber: this.state.pdfPageNumber - 1 <= 1 ? 1 : this.state.pdfPageNumber - 1 })
  }
  goToNextPage = () => {
    this.setState({ pdfPageNumber: this.state.pdfPageNumber + 1 >= this.state.numPages ? this.state.numPages : this.state.pdfPageNumber + 1 })
  }
  toggleMyHomeFolders = () => {
    if (this.state.myHomeFoldersOpen) {
      this.setState({ myHomeFoldersOpen: false })
    } else {
      this.setState({ myHomeFoldersOpen: true })
    }
  }
  toggleSplit = () => {
    this.setState({
      filesSide: [],
      foldersSide: [],
      currFolderSide: null,
      preFolderSide: null,
      navigationsSide: []
    })
    if (this.state.showSplit) {  //when split is clicked showSplit is assigned as 'false'
      this.setState({ showSplit: false })

    } else {
      this.constructNavigation(true)
      this.fetchStorageItems(null, null, true)
      this.setState({ showSplit: true })
    }
  }
  onPageChange = (pageIndex) => {
    this.setState({
      currentPageNumber: pageIndex
    }, () => {
      this.getPendingTask(this.state.activeTab);
    });
  }
  getPendingTask = () => {
    let routeKey = "STORAGE";
    let jobsStates = ["PROCESSING"];
    FileJobsService.PendingJobs(routeKey, jobsStates, this.state.currentPageNumber, 5)
      .then((response) => {
        let responseData = response.jobsStateDTOS;
        if (response.status === 'SUCCESS') {
          if (responseData.content.length !== 0) {
            this.setState({
              pendingDTOS: responseData.content,
              totalPagesPending: responseData.totalPages,
            });
          }

        } else {
          this.setState({ errorMessage: response.errorMessage, totalPagesPending: responseData.totalPages });
        }
        if (this.state.pendingDTOS.length === 0) {
          this.setState({ errorMessage: "No Pending Jobs" });
        }
      });
  }
  toggleTasks = () => {
    this.setState({
      showTasksPanel: !this.state.showTasksPanel
    }, () => {
      if (this.state.showTasksPanel) {
        this.setState({
          totalPagesPending: 0,
          currentPageNumber: 0
        }, () => {
          this.getPendingTask();
        })
      }
    })
  }
  createFolder = (folderName, isSidePane) => {
    let currFolder;
    let storageId;
    let rootFolder;
    if (isSidePane) {
      currFolder = this.state.currFolderSide ? this.state.currFolderSide : ''
      storageId = this.state.sourceStorageIdSide ? this.state.sourceStorageIdSide : ''
      rootFolder = this.state.sourceRootFolderSide ? this.state.sourceRootFolderSide : ''
    } else {
      currFolder = this.state.currFolder ? this.state.currFolder : ''
      storageId = this.state.sourceStorageId ? this.state.sourceStorageId : ''
      rootFolder = this.state.sourceRootFolder ? this.state.sourceRootFolder : ''
    }
    let prefixName = path.join(currFolder, folderName)
    if (!prefixName.endsWith("/")) {
      prefixName = prefixName + "/"
    }
    StorageService.createPrefix(prefixName, storageId, rootFolder)
      .then((response) => {
        this.closeCreateFolder()
        this.setState({ folderToBeCreate: null })
        if (isSidePane) {
          this.toggleFolderCreateSplit()
          this.fetchStorageItems(prefixName, null, true)
        } else {
          this.toggleFolderCreate()
          this.fetchStorageItems(prefixName, null, false)
        }
      })
  }
  closeCreateFolder = (event) => {
    this.setState({ popoverOpenFolderCreate: false })
  }
  closeCreateFolderSplit = event => {
    this.setState({ popoverOpenFolderCreateSplit: false })
  }
  onPreFolderClick = (event) => {
    event.preventDefault()
    this.fetchStorageItems(this.state.preFolder)
  }
  onCreateFolderClick = (event, isSidePane) => {
    event.preventDefault()
    this.createFolder(this.state.folderToBeCreate, isSidePane)
  }
  onNavigationClick = (event) => {
    event.preventDefault()
    let foldpath = "folder"
    this.previewFile(trimFolderName(event.target.dataset.name), foldpath)
    let isSideSplited = event.target.dataset.issidesplited === 'true' ? true : false
    this.fetchStorageItems(event.target.dataset.name, null, isSideSplited)
  }
  constructNavigation = (isSideSplited) => {
    isSideSplited = !isSideSplited ? false : true
    let currFolder = !isSideSplited ? this.state.currFolder : this.state.currFolderSide
    let homeNav = <BreadcrumbItem key={uuidv4()} active>Home</BreadcrumbItem>
    if (currFolder) {
      homeNav = <BreadcrumbItem key={uuidv4()} ><a href={() => false} data-name='' data-issidesplited={isSideSplited} onClick={this.onNavigationClick}>Home</a></BreadcrumbItem>

    }
    let navigations = [
      homeNav
    ]
    if (currFolder) {
      let prefixes = currFolder.split('/').slice(0, -1)
      let lastPrefix = prefixes.length > 0 ? prefixes.pop() : null
      let name = ''
      for (const prefix of prefixes) {
        name = name + prefix + '/'
        navigations.push(<BreadcrumbItem key={uuidv4()} ><a href={() => false} data-name={name} data-issidesplited={isSideSplited} onClick={this.onNavigationClick}>{prefix}</a></BreadcrumbItem>)
      }
      if (lastPrefix) {
        navigations.push(<BreadcrumbItem key={uuidv4()} active>{lastPrefix}</BreadcrumbItem>)
      }
    }
    let actualNavigations = !isSideSplited ? 'navigations' : 'navigationsSide'
    this.setState({ [actualNavigations]: navigations, currentnavi: actualNavigations })

    if (this.state.currentnavi === 'navigations') {
      isSideSplited = false;

    }
    if (this.state.currentnavi === 'navigationsSide') {
      isSideSplited = true;
    }

  }
  toggleFolderCreate = () => {
    this.setState({
      popoverOpenFolderCreate: !this.state.popoverOpenFolderCreate
    });
  }
  toggleFolderCreateSplit = () => {
    this.setState({ popoverOpenFolderCreateSplit: !this.state.popoverOpenFolderCreateSplit })
  }
  handleInputChange = (event) => {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }
  handleInit() {
    // console.log('FilePond instance has initialised', this.pond);
  }
  toggleUpload = () => {
    if (this.state.showUploadModal) {
      this.setState({ showUploadModal: false })
    } else {
      this.setState({ showUploadModal: true })
    }
  }
  toggleConfirmationCopyMove = () => {
    if (this.state.showConfirmationCopyMove) {
      this.setState({ showConfirmationCopyMove: false })
    } else {
      this.setState({ showConfirmationCopyMove: true })
    }
  }
  toggleRenameCopyMoveAction = () => {
    if (this.state.showCopyMoveActionModal) {
      this.setState({ showCopyMoveActionModal: false })
    } else {
      this.setState({ showCopyMoveActionModal: true })
    }
  }
  toggleFolderUpload = () => {
    if (this.state.showFolderUploadModal) {
      this.setState({ showFolderUploadModal: false })
    } else {
      this.setState({ showFolderUploadModal: true })
    }
  }
  toggleSplitUpload = () => {
    if (this.state.showSplitUploadModal) {
      this.setState({ showSplitUploadModal: false })
    } else {
      this.setState({ showSplitUploadModal: true })
    }
  }
  toggleSplitFolderUpload = () => {
    if (this.state.showSplitFolderUploadModal) {
      this.setState({ showSplitFolderUploadModal: false })
    } else {
      this.setState({ showSplitFolderUploadModal: true })
    }
  }
  RenameAction = () => {
    if (this.state.dataAction.paths !== undefined) {
      if (this.state.dataAction.paths.length === 1) {
        if (!this.state.dataAction.paths[0].isDir) {
          this.setState({
            renameNewValue : this.state.dataAction.paths[0].sourcePath.replace(/^.*[\\/]/, '')
          },()=>{
          })
        } else {
          var splitbySlash = this.state.dataAction.paths[0].sourcePath.split("/");
          this.setState({
            renameNewValue : splitbySlash[splitbySlash.length-2]
          },()=>{
          })
        }
      }
    }
  }
  renameCopyMoveUpdate = (e) => {
    let copymovedataNew = this.state.dataAction;
    if (copymovedataNew.paths.length === 1) {
      if (!copymovedataNew.paths[0].isDir) {
        copymovedataNew.paths[0].newName = this.state.renameNewValue;
      } else {
        copymovedataNew.paths[0].newName = this.state.renameNewValue;
      }
    }
    this.toggleConfirmationCopyMove();

    if (this.state.modeTransfer === "Copy") {
      this.copyAction(copymovedataNew)

    } else if (this.state.modeTransfer === "Move") {
      this.moveAction(copymovedataNew)
    }
  }
  resetSamedirectoryDataDTO = () => {
    this.setState({
      dataAction: "",
      modeTransfer: ""
    })
  }
  createUploadFolders = (currFolder) => {
    let foldersToBeCreate = []
    currFolder = !currFolder ? '' : currFolder
    for (const file of this.state.folderUploadFiles) {
      let folderName = (file._relativePath || file.webkitRelativePath).replace(file.name, "")
      if (folderName.startsWith("/")) {
        folderName.replace("/", "")
      }
      if (foldersToBeCreate.indexOf(folderName) === -1) {
        foldersToBeCreate.push(folderName)
        const actulaFolderPath = path.join(currFolder, folderName)
        StorageService.createPrefix(actulaFolderPath)
          .then(response => { })
      }
    }
  }
  handleFolderUploadFiles = (e, isFromSplit) => {
    this.setState({ folderUploadFiles: [...e.target.files] }, () => {
      if (isFromSplit) {
        this.toggleSplitFolderUpload()
      } else {
        this.toggleFolderUpload()
      }
    })
  }
  toggleViewFiles = () => {
    if (this.state.showViewFilesModal) {
      this.setState({ showViewFilesModal: false })
    } else {
      this.setState({ showViewFilesModal: true })
    }
  }
  selectCopyFile = (fromwats, pastewat, isDirectory) => {
    this.setState({ sourcecopy: fromwats, pastefrom: pastewat, isitDir: isDirectory })
  }
  selectMoveFile = (fromwats,pastewat,isDirectory) => {
    this.setState({sourcemove:fromwats,pastefrom:pastewat,isitDir:isDirectory})   
  } 
  toggleShowFiles = (ShowFold,fromwats,from,isDirectory) => {

    if (this.state.showFilesModal) {
      this.setState({ showFilesModal: false }, () => {
        this.afteraction(ShowFold, fromwats, from, isDirectory)
      })
    } else {
      let platformDefault = this.getPlatformDefaultConfig(this.state.configArray);
      if (platformDefault !== null) {
        this.setState({ showFilesModal: true, destinationStorageId: null, destinationRootFolder: null, activeConfigPath: platformDefault.id }, () => {
          this.afteraction(ShowFold, fromwats, from, isDirectory)
        })
      }
    }

  }
  afteraction = (ShowFold,fromwats,from,isDirectory) =>{
    if(ShowFold === 'true'){
      if(from === 'Move'){
        this.setState({
          showbutton: 'Move',
          sourcemove: fromwats,
          showAllFolders: true,
          isitDir: isDirectory
        }, () => {
          this.fetchStorageItems(null, null, false)
        })
      } else {
        this.setState({
          showbutton: 'Copy',
          sourcecopy: fromwats,
          showAllFolders: true,
          isitDir: isDirectory
        }, () => {
          this.fetchStorageItems(null, null, false)
        })
      }
    }
  }
  cancelMove = () => {
    this.setState({ showFilesModal: false });
  }
  pasteFolder = (split, pastedetails, isDirectory) => {
    let pastefiles = pastedetails;
    if (split === false) { // for home folder
      if (this.state.currFolder === null) {
        pastefiles = '/'
      }
      else if (pastefiles === "emptyfolder") {
        pastefiles = this.state.currFolder;
      }
    }
    if (split === true) {
      if (this.state.currFolderSide === null) {
        pastefiles = '/'
      }
      else if (pastefiles === "emptyfolder") {
        pastefiles = this.state.currFolderSide;
      }
    }
 
    if(this.state.pastefrom === "Copy"){
      this.copyFolder(split,pastefiles)
    }
    else if(this.state.pastefrom === "Move"){
      this.moveFolder(split,pastefiles)
    }
    else{
    }
  }
  copyFolder = (split,pastefiles) => {
    let dirornot = this.state.isitDir
    let currFolder = this.state.currFolder ? this.state.currFolder : ''
    if (pastefiles !== undefined) {
      currFolder = pastefiles;
    }
    if (currFolder == null) {
      currFolder = "/"
    }
    this.setState({destinationcopy: currFolder})
    let destifolder = currFolder;
    if (destifolder == null) {
      destifolder = "/"
    }

    let copydata = this.ConstructJobOperationData(destifolder, dirornot, this.state.sourcecopy);
    let soruceFile = this.state.sourcecopy.substring(0, this.state.sourcecopy.lastIndexOf("/"));
    if (destifolder === "") {
      destifolder = "/";
    }
    if (destifolder === soruceFile + "/" && !this.state.isitDir && (this.state.sourceStorageId === this.state.destinationStorageId)) {  // if copy same directory
      this.setState({
        dataAction: copydata,
        modeTransfer: "Copy"
      }, () => {
        this.RenameAction();
        this.toggleShowFiles();
        this.toggleConfirmationCopyMove();  // open confirmation popup of copy  
      })
    } else {
      if (dirornot) {
        let modifiedSourcepath = this.removelastElement(copydata)
        if (modifiedSourcepath + "/" === destifolder) {
          this.setState({
            dataAction: copydata,
            modeTransfer: "Copy"
          }, () => {
            this.RenameAction();
            this.toggleShowFiles();
            this.toggleConfirmationCopyMove();  // open confirmation popup of copy  
          })
        } else {
          this.copyAction(copydata);
        }
      } else {
        this.copyAction(copydata);
      }
    }
  }
  copyAction = (copydata) => {
    FileJobsService.CopyFile(copydata)
      .then((response) => {
      });
    this.setState({ showFilesModal: false, sourceStorageId: this.state.destinationStorageId, sourceRootFolder: this.state.destinationRootFolder })
  }
  removelastElement = (copyD) => {
    let val = copyD.paths[0].sourcePath;
    var arr = val.split("/");
    var removeCount = 2;
    arr.splice(arr.length - removeCount, removeCount);
    return (arr.join('/'));
  }
  moveFolder = (split, pastefiles) => {
    let dirornot = this.state.isitDir
    let currFolder = this.state.currFolder ? this.state.currFolder : ''
    if (pastefiles !== undefined) {
      currFolder = pastefiles;
    }
    if (currFolder == null) {
      currFolder = "/"
    }
    this.setState({destinationmove: currFolder})
    let destifolder = currFolder;
    if (destifolder == null) {
      destifolder = "/"
    }
    let movedata = this.ConstructJobOperationData(destifolder, dirornot, this.state.sourcemove);

    let soruceFile = this.state.sourcemove.substring(0, this.state.sourcemove.lastIndexOf("/"));
    if (destifolder === "") {
      destifolder = "/";
    }
    if (destifolder === soruceFile + "/" && (this.state.sourceStorageId === this.state.destinationStorageId)) {
      this.setState({
        dataAction: movedata,
        modeTransfer: "Move"
      }, () => {
        this.RenameAction();
        this.toggleShowFiles();
        this.toggleConfirmationCopyMove();  // open confirmation popup of copy
        // toast.info("Cannot Move. The destination folder is the same as the source folder")
      })
    } else {
      if (dirornot) {
        let modifiedSourcepath = this.removelastElement(movedata)
        if (modifiedSourcepath + "/" === destifolder) {
          this.setState({
            dataAction: movedata,
            modeTransfer: "Move"
          }, () => {
            this.RenameAction();
            this.toggleShowFiles();
            this.toggleConfirmationCopyMove();  // open confirmation popup of copy  
          })
        } else {
          this.moveAction(movedata);
        }
      } else {
        this.moveAction(movedata);
      }
    }

  }
  moveAction = (movedata) => {
    FileJobsService.MoveFile(movedata)
      .then((response) => {
      });
    this.setState({ showFilesModal: false, sourceStorageId: this.state.destinationStorageId, sourceRootFolder: this.state.destinationRootFolder })

  }
/**
   * 
   * @param {destination path} destination 
   * @param {folder or file} dirornot 
   * @param {source path} sourceMove 
   * @returns 
   */
  ConstructJobOperationData = (destination, dirornot, sourceMove) => {
    let data = {
      "destinationPath": destination,
      "destinationStorage": {
        "rootFolder": this.state.destinationRootFolder !== null ? this.state.destinationRootFolder : null,
        "storageId": this.state.destinationStorageId !== null ? this.state.destinationStorageId : null
      },
      "paths": [
        {
          "isDir": dirornot,
          "sourcePath": sourceMove

        }
      ],
      "sourceStorage": {
        "rootFolder": this.state.sourceRootFolder,
        "storageId": this.state.sourceStorageId
      }
    }
    if (this.state.sourceStorageId === null) {
      delete data["sourceStorage"]
    }
    if (this.state.destinationStorageId === null) {
      delete data["destinationStorage"]
    }
    return data;
  }
  toggleExtract = () => {
    if (this.state.showExtractModal) {
      this.setState({ showExtractModal: false })
    } else {
      this.setState({ showExtractModal: true })
    }
  }
  toggleStorageConfig = () => {
    this.setErrorMessage("");
    if (this.state.showStorageConfig) {
      this.setState({ showStorageConfig: false, editId: "" })
    } else {
      this.clearStorageConfigModalData();
      this.setState({
        showStorageConfig: true,
      })
    }
  }
  toggleStorageBucketList = () => {
    this.setErrorMessage("");
    if (this.state.showStorageBucketList) {
      this.setState({
        showStorageBucketList: false,
        CloudBucketList: []
      })
    } else {
      this.GetBucketsList();
      this.setState({
        showStorageBucketList: true,
        SelectAllFlag: false,
      })
    }
  }
  clearStorageConfigModalData = () => {
    if (this.state.editId === "") {
      this.setState({
        name:"",
        description:"",
        provisionerId:"",
        provisionerType:"",
        isStoragePrimary:false,
        isStorageStatus:true,
        SelectedBucketList:[]
      })
    }
  }
  // Get provisioner list by service
  getProvisionerServices = () => {
    return ProvisionerService.getProvisionerByService(provisionerService.storage)
    .then((response) => {
        if (response.status === 'SUCCESS') {
          let contents = response.provisionerDTOPage.content;
          if (contents !== null && contents !== undefined && contents.length > 0) {
            let provisionerList = [];
            for (var i = 0; i < contents.length; i++) {
              provisionerList.push({
                label: contents[i].provisionerType + ' : ' + contents[i].name,
                value: contents[i].id
              })
            }
            this.setState({
              provisionerNames: provisionerList
            })
          } else {
            this.setState({
              provisionerNames: []
            })
          }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      }
      );
  }
  refreshstorage = (e,st) =>{
    if(st === "true"){
      this.fetchStorageItems(this.state.currFolderSide, null, true)
    }
    else if (st === "false") {
      this.fetchStorageItems(this.state.currFolder, null, false)
    }
    else if (st === "both") {
      this.fetchStorageItems(this.state.currFolder, null, false)
      this.fetchStorageItems(this.state.currFolderSide, null, true)
    }

  }
  sortAsc = (type) => {
    this.setState({
      files: [...this.state.FilterFilesData].sort((a, b) => {
        // convert to strings and force lowercase
        let _a = a[type]
        let _b = b[type]
        _a = typeof _a === 'string' ? _a.toLowerCase() : _a.toString()
        _b = typeof _b === 'string' ? _b.toLowerCase() : _b.toString()

        if (type === 'size') {
          return _a - _b
        } else {
          return _a.localeCompare(_b)
        }
      })
    })
    if (type === 'name') {
      this.setState({
        folders: [...this.state.FilterFolderData].sort((a, b) => {
          // convert to strings and force lowercase
          a = typeof a === 'string' ? a.toLowerCase() : a.toString()
          b = typeof b === 'string' ? b.toLowerCase() : b.toString()

          return a.localeCompare(b)
        })
      })
    }
  }
  sortDesc = (type, isSideSplited) => {
    let actualFiles = null
    let actualFolders = null
    if (!isSideSplited) {
      actualFiles = 'files'
      actualFolders = 'folders'
    } else {
      actualFiles = 'filesSide'
      actualFolders = 'foldersSide'
    }
    this.setState({
      [actualFiles]: [...this.state.FilterFilesData].sort((a, b) => {
        // convert to strings and force lowercase
        let _a = a[type]
        let _b = b[type]
        _a = typeof _a === 'string' ? _a.toLowerCase() : _a.toString()
        _b = typeof _b === 'string' ? _b.toLowerCase() : _b.toString()

        if (type === 'size') {
          return _b - _a
        } else {
          return _b.localeCompare(_a)
        }
      })
    })
    if (type === 'name') {
      this.setState({
        [actualFolders]: [...this.state.FilterFolderData].sort((a, b) => {
          // convert to strings and force lowercase
          a = typeof a === 'string' ? a.toLowerCase() : a.toString()
          b = typeof b === 'string' ? b.toLowerCase() : b.toString()

          return b.localeCompare(a)
        })
      })
    }
  }
  sortBy = (event, type) => {

    this.resetOthers = (event, type) => {
      if (type === 'name') {
        document.getElementById('storage-label-size').innerHTML = 'Size<i className="fas fa-sort ml-2"></i>'
        document.getElementById('storage-label-created').innerHTML = 'Last Modified<i className="fas fa-sort ml-2"></i>'
      } else if (type === 'size') {
        document.getElementById('storage-label-name').innerHTML = 'Name<i className="fas fa-sort ml-2"></i>'
        document.getElementById('storage-label-created').innerHTML = 'Last Modified<i className="fas fa-sort ml-2"></i>'
      } else if (type === 'created') {
        document.getElementById('storage-label-size').innerHTML = 'Size<i className="fas fa-sort ml-2"></i>'
        document.getElementById('storage-label-name').innerHTML = 'Name<i className="fas fa-sort ml-2"></i>'
      }
    }

    const sortType = event.target.dataset.sort
    if (sortType === 'null') {
      event.target.dataset.sort = "asc"
      event.target.innerHTML = event.target.dataset.label + '<i className="fas fa-sort-amount-up ml-2"></i>'
      this.sortAsc(type)
    } else if (sortType === 'asc') {
      event.target.dataset.sort = "desc"
      event.target.innerHTML = event.target.dataset.label + '<i className="fas fa-sort-amount-down ml-2"></i>'
      this.sortDesc(type)
    } else if (sortType === 'desc') {
      event.target.dataset.sort = "asc"
      event.target.innerHTML = event.target.dataset.label + '<i className="fas fa-sort-amount-up ml-2"></i>'
      this.sortAsc(type)
    }
    this.resetOthers(event, type)
  }
  showFolderUpload = () => {
    this.folderUploadRef.current.click()
  }
  showSplitFolderUpload = () => {
    this.splitFolderUploadRef.current.click()
  }
  // FilePond upload process, it can be re-usable
  _filePondProcess = (fieldName, file, metadata, load, error, progress, abort, transfer, options, currFolder, isFromSplit) => {
    currFolder = currFolder ? currFolder : ''
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const fileToBeUpload = file
    let fileName = fileToBeUpload._relativePath ? fileToBeUpload._relativePath : (fileToBeUpload.webkitRelativePath ? fileToBeUpload.webkitRelativePath : fileToBeUpload.name)
    if (fileName.startsWith('/')) {
      fileName = fileName.replace('/', '')
    }
    const objectName = path.join(currFolder, fileName)
    StorageService.uploadObjectUrl(objectName, this.state.sourceStorageId, this.state.sourceRootFolder)
      .then((response) => {
        if (response.type === provisioners.google) {
          axios({
            url: response.upload_url,
            baseURL: '',
            data: {},
            headers: {
              'content-type': fileToBeUpload.type,
              'x-goog-resumable': 'start'
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            const resumableLink = resp.headers.location
            CommonService({
              url: resumableLink,
              baseURL: '',
              data: fileToBeUpload,
              headers: {
                'content-type': "multipart/form-data"
              },
              method: 'PUT',
              cancelToken: source.token,
              onUploadProgress: function (e) {
                progress(e.lengthComputable, e.loaded, e.total)
              }
            }).then((resp) => {
              load(fileToBeUpload.name)
            })
          })
        } if (response.type === provisioners.aws) {
          var rest = response.fields;
          var formData = new FormData();
          for (const [key, value] of Object.entries(rest)) {
            formData.append(key, value)
          }
          formData.append("file", fileToBeUpload)
          axios({
            url: response.upload_url,
            data: formData,
            headers: {
              'content-type': "multipart/form-data"
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            load(fileToBeUpload.name)
          })
        }
        if (response.type === provisioners.azure) {
          axios({
            url: response.upload_url,
            data: fileToBeUpload,
            headers: {
              'content-type': "multipart/form-data",
              'x-ms-blob-type': 'BlockBlob'
            },
            method: 'PUT',
            cancelToken: source.token
          }).then((resp) => {
            load(fileToBeUpload.name)
          })
        }

      })
    return {
      abort: () => {
        try {
          // This function is entered if the user has tapped the cancel button
          source.cancel()

          // Let FilePond know the request has been cancelled
          abort();
        } catch (ex) {
        }
      }
    }
  }
  filePondProcess = (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
    this._filePondProcess(fieldName, file, metadata, load, error, progress, abort, transfer, options, this.state.currFolder, false)
  }
  filePondSplitProcess = (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
    this._filePondProcess(fieldName, file, metadata, load, error, progress, abort, transfer, options, this.state.currFolderSide, true)
  }
  handlePageClick = (pageNumber) => {
    let selected = pageNumber.selected + 1;
    this.setState({ activePage: selected }, () => {
      this.csvLoadData(selected);
    });
  }
  csvLoadData = (page) => {
    this.setState({
      loading: "block"
    })
    let csvPath = {
      path: this.state.fileName,
      delimiter: this.state.delimiter
    }
    RunService.csvDataPagination(csvPath, page, this.state.sourceStorageId, this.state.sourceRootFolder)
      .then((response) => {
        if (response.records.length !== 0) {
          this.setState({
            myContent: []
          });
          let jsonCsv = [];
          for (var i = 0; i < response.records.length; i++) {
            var removeSlash = response.records[i].replace(/\\/g, "");
            jsonCsv.push(JSON.parse(removeSlash));
          }
          this.setState({
            myContent: jsonCsv,
            totalPages: response.totalPages,
            totalRecords: response.totalRecords,
            loading: "none"
          }
          )
        } else {
          this.setState({
            loading: "none"
          })
        }
      }).catch((error) => {
      });
  }
  SaveChooseBucketList = () => {
    this.toggleStorageBucketList();
    let selectedBucket = this.state.CloudBucketList.filter(item => item.chooseBucketFlag === true);
    this.setState({
      SelectedBucketList: selectedBucket
    })

  }
  // Add New storage config details
  AddNewStorageConfig = (event) => {
    event.preventDefault();
    if ((this.state.name === "" || this.state.name === undefined)) {
      this.setErrorMessage("Please Enter Name");
    } else if (this.state.provisionerId === "" || this.state.provisionerId === undefined) {
      this.setErrorMessage("Please Select Provisioner");
    } else if (this.state.SelectedBucketList.length === 0) {
      this.setErrorMessage("Please Add atleast one bucket configuration");
    }
    else {
      const newArray = this.state.SelectedBucketList.map(({ chooseBucketFlag, dateCreated, ...rest }) => rest)
      this.setErrorMessage("");
      let configData = {
        name: this.state.name,
        accountId: localStorage.getItem("accountId"),
        provisionerId: this.state.provisionerId,
        provisionerType: this.state.provisionerType,
        description: this.state.description,
        primary: this.state.isStoragePrimary,
        storageStatus: this.state.isStorageStatus === true ? "ENABLED" : "DISABLED",
        storageConfig: {
          bucketStorages: newArray,
          storageType: "BUCKET"
        }
      }
      if (this.state.editId !== "") {
        StorageConfigService.UpdateStorageConfig(this.state.editId, configData)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              this.toggleStorageConfig();
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Storage Configuration Updated Successfully!</b></i>);
              this.GetAllStorageConfig();
            } else {
              this.toggleStorageConfig();
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
            }
          }
          );
      } else {
        // Add New storage configuration
        StorageConfigService.PostStorageConfiguration(configData)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              this.toggleStorageConfig();
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Storage Configuration Created Successfully!</b></i>);
              this.GetAllStorageConfig();
            } else {
              this.toggleStorageConfig();
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
            }
          }
          );
      }
    }
  }
  onPreviewClick = () => {
    this.setState({ showPreview: !this.state.showPreview }, () => {
      this.previewFile(this.state.currFolder, "file", this.state.sourceStorageId, this.state.sourceRootFolder)
    })
  }
  render() {
    return (
        <>
        <PanelHeader
          content={
            <div className="header text-center">
            </div>
          }
        />
        <div className="content">
        <Row>
            <Col lg={12} md={12} xs={12} >
              <Card className="storage-card">
                <CardHeader>
                  <div className="col">
                    <Row>
                      <Col xs={12} md="3">
                        <b>Storage Management </b>
                        {(this.state.userRole === "TENANT_ADMIN" || this.state.userRole === "PLATFORM_ADMIN") &&
                          <span title="Add New Configuration"><i style={{ cursor: "pointer", color: "#4774d9", paddingLeft: 10 }} onClick={e => { this.AddNewStorageBtnClick() }} className="fas fa-plus-circle"></i></span>
                        }
                      </Col>
                      <Col xs={12} md="3" style={{ paddingTop: 9 }}>
                        <form>
                          <InputGroup className="no-border" style={{ border: "1px solid #d3d3d3" }}>
                            <Input placeholder="Search files and folders" onChange={event => this.onChangeStorageSearch(event.target.value)}
                              value={this.state.searchKey}
                              style={{ color: 'black', height: '30px', fontSize: '14px', backgroundColor: '#fff' }} />

                            <InputGroupAddon addonType="append" style={{ backgroundColor: '#fff', borderRadius: '5px', height: '30px' }}>
                              <InputGroupText style={{ backgroundColor: '#fff', borderRadius: '5px', height: '30px' }}>
                                &nbsp; &nbsp; <i className="now-ui-icons ui-1_zoom-bold" />
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </form>
                      </Col>
                      <Col xs={12} md="2" className="text-center">
                        <ButtonGroup className="chatLoading" style={{ verticalAlign: 'sub', display: this.state.loading }}>
                          <Badge color="info"> Loading... </Badge>
                        </ButtonGroup>
                      </Col>
                      <Col xs={12} md="4" style={{ textAlign: "right" }}>
                        <ButtonGroup className="">
                          <Button
                            className="storage-view-btn"
                            size="sm"
                            color="info"
                            id="preview"
                            onClick={() => this.onPreviewClick()}
                            active={this.state.showPreview === true}
                          >
                            <i className="fas fa-eye" style={{ fontSize: "15px" }}></i>
                          </Button>   &nbsp; &nbsp; &nbsp;
                          <UncontrolledTooltip placement="top" target="preview" delay={0}>
                            Preview
                          </UncontrolledTooltip>
                          <Button
                            className="storage-view-btn"
                            size="sm"
                            color="info"
                            id="table"
                            onClick={() => this.setViewSelected(1)}
                            active={this.state.viewSelected === 1}>
                            <i className="fas fa-th-list"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target="table" delay={0}>
                            Table
                          </UncontrolledTooltip>
                          <Button
                            className="storage-view-btn"
                            size="sm"
                            color="info"
                            id="cards"
                            onClick={() => this.setViewSelected(2)}
                            active={this.state.viewSelected === 2}>
                            <i className="fas fa-th-large"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target="cards" delay={0}>
                            Cards
                          </UncontrolledTooltip>
                          <Button
                            className="storage-view-btn"
                            size="sm"
                            color="info"
                            id="split"
                            onClick={() => this.toggleSplit()}
                            active={this.state.showSplit}
                          >
                            <i className="fas fa-columns"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target="split" delay={0}>
                            Split
                          </UncontrolledTooltip>
                          <Button
                            className="storage-view-btn"
                            size="sm"
                            color="info"
                            id="tasks"
                            onClick={() => this.toggleTasks()}
                            active={this.state.showTasksPanel}
                          >
                            <i className="fas fa-tasks"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target="tasks" delay={0}>
                            Tasks
                          </UncontrolledTooltip>
                        </ButtonGroup>
                      </Col>
                    </Row>
                  </div>
                </CardHeader>
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
                <CardBody style={{backgroundColor:"#f4f5f9", padding: "15px 15px 0px 15px"}}>
                  <Row>
                  <Col xs={12} sm={12} md={12} lg={3} xl={3}  style={{display:this.state.showSplit ? "none" : "block"}} className="storage-side-pane-col ">
                      <Card className="storage-content-card storage-card  equalheight">
                        <CardBody className="border-top storage-content">
                          <div>
                                    {this.state.configArray.map((item,index) => ( <div className="card-plain">
                                      <Row>
                                        <Col>
                                          <div onMouseEnter={e => { this.handleMouseHover(item.name) }}
                                            onMouseLeave={e => this.handleMouseLeave(e)}>
                                            <CardHeader role="tab" className={item.storageStatus === "DISABLED" ? "disablebtn" : ""} >
                                              <a
                                                aria-expanded={this.state.openedCollapses.includes(
                                                  "collapseStorage" + index
                                                )}
                                                href="#pablo"
                                                data-parent="#accordion"
                                                data-toggle="collapse"
                                                onClick={e => {
                                                  e.preventDefault();
                                                  this.collapsesToggle("collapseStorage" + index);
                                                }}
                                              >
                                                  {item.platformDefault ?
                                                  <Row className={item.id === this.state.activeConfigPath ? "activeStorageConfig" : ""}>
                                                    <Col xs="12">
                                                      <div title={item.name} className="overflowStyle" style={{ fontSize: 14, color: "#525f7f" }} onClick={e => { this.onBucketNameCickEvent(item, null) }}>
                                                        <img src={provisionerTypeLogo(undefined)} className="imgStorageList" alt="aws" />
                                                        <span className="pl-2">{default_LabelStorageName}</span>
                                                      </div>
                                                    </Col> 
                                                  </Row> :
                                                  <Row className={item.id === this.state.activeConfigPath ? "activeStorageConfig" : ""}>
                                                    <Col xs="8">
                                                      <div title={item.name} className="overflowStyle" style={{ fontSize: 14, color: "#525f7f" }}>
                                                        <img src={provisionerTypeLogo(item.provisionerType)} className="imgStorageList" alt="aws" />
                                                        <span className="pl-2">{item.name}</span>
                                                      </div>
                                                    </Col>
                                                    <Col xs="2">
                                                      <i className="now-ui-icons arrows-1_minimal-down" style={{
                                                        marginTop: 3, marginLeft: "-14px"
                                                      }} />
                                                    </Col>
                                                  </Row>
                                                  }
                                              </a>
                                            </CardHeader>
                                          </div>

                                        </Col>

                                        {!item.platformDefault && <Col xs="1" className="mt-3">

                                          <div>
                                            {/* Popup action below */}
                                            {this.state.mouseHoverStorageName === item.name && <UncontrolledDropdown direction="down">
                                              <DropdownToggle tag="span"
                                                onClick={e => e.preventDefault()}
                                                style={{ cursor: 'pointer' }}>
                                                <i className="fas fa-ellipsis-v" style={{ fontSize: '12px', marginRight: 10 }} />
                                              </DropdownToggle>
                                              <DropdownMenu persist right className="dropdown-menu-arrow" flip={false} modifiers={{
                                                flip: {
                                                  behavior: "flip",
                                                  enabled: true
                                                }, preventOverflow: { boundariesElement: 'window' }
                                              }}>

                                                <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => { this.onStorageConfigEdit(e, item.id, item.name) }} className="storagedropdown">
                                                  <span>    <i className="fas fa-edit mr-3" />Edit</span>
                                                </DropdownItem>

                                                <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => { this.onStorageConfigDeleteConfirmation(e, item.id, item.name) }} className="storagedropdown">
                                                  <span>    <i className="fas fa-trash mr-3" />Delete</span>
                                                </DropdownItem>

                                              </DropdownMenu>
                                            </UncontrolledDropdown>
                                            }
                                          </div>

                                        </Col>}
                                      </Row>
                                                  <Collapse
                                                    role="tabpanel"
                                                    isOpen={this.state.openedCollapses.includes(
                                                      "collapseStorage"+index
                                                    )}
                                                  >
                                                    {item.storageConfig !== null && item.storageConfig.bucketStorages.map((cItem, index) => (<CardBody>
                                                    <Row>
                                                        <Col lg="12">
                                                        <span style={{marginLeft:10}} className={this.state.selectedStorage === cItem.bucketName ? "activeBucket" : ""} onClick={e => {this.onBucketNameCickEvent(item,cItem)}}>
                                                        <img src={awsbucket} className="imgBucket" alt="aws"/><span title={cItem.bucketName} className="bucketListView">{cItem.bucketName}</span></span>
                                                  
                                                        </Col>
                                                      </Row>
                                                    </CardBody>))}
                                                  </Collapse>
                                                                                       

                                                </div>))}

                                  {/* </Scrollbars>    */}
                          </div>
                            {this.state.configArray.length === 0 && <div className="df-text-black-50 text-center">
                              <span className="">No Storage Configured</span>
                            </div>
                            }
                        </CardBody>
                        <CardFooter className="storage-btn storage-side-pane-footer border-top storagetxt footer_992 trashfooter" 
                        onClick={e => {this.getTrashFile('trash/')}}
                        >
                        <i className="fas fa-trash-alt"></i> Trash
                        </CardFooter>
                      </Card>
                    </Col>
                  {/* show Split screen */}
                   {this.state.showSplit &&
                    <Col xs={12} sm={this.state.showPreview ? "8" : "12"}>
                    <div>
                    <Row>
                
                    <Col xs={12} sm={this.state.showPreview ? "6" : "6"} className="storage-side-pane-col">
                      <Card className="storage-content-card storage-card">
                        <CardSubtitle className="clearfix px-2">
                        <Row>
                        <Col xs={12} md="9">
                           <ButtonGroup className="">
                              <Button
                              className="storage-btn"
                              size="sm"
                              color="link"   
                              id='refresh'
                              onClick={e => this.refreshstorage(e, 'false')}
                            >
                              <i className="fas fa-sync-alt"></i>                              
                             </Button>
                            <UncontrolledTooltip placement="top" target="refresh" delay={0}>
                              Reload
                            </UncontrolledTooltip>
                            <Breadcrumb listClassName="bg-transparent storage-nav-breadcrumb storagetxt" listTag="div">
                            {this.state.navigations}
                          </Breadcrumb> 
                            </ButtonGroup>                           
                        </Col>  
                        <Col xs={12} md="2" className={this.state.itstrash ? "fa-disabled" : ""}>
                          <ButtonGroup className="">
                             <Button
                              className="storage-btn"
                              size="sm"
                              color="link"
                              id='create-folder'
                              onClick={this.toggleFolderCreate}
                            >
                              <i className="fas fa-folder-plus font15"></i>
                            </Button>
                            <UncontrolledPopover
                              placement="bottom"
                              target="create-folder"
                              className="popover-primary"
                              trigger="legacy"
                            >
                              <PopoverHeader>Create Folder
                              </PopoverHeader>
                              <PopoverBody>
                                <InputGroup>
                                  <Input
                                    placeholder="Folder Name"
                                    name="folderToBeCreate"
                                    value={this.state.folderToBeCreate}
                                    onChange={this.handleInputChange} />
                                  <InputGroupAddon addonType="append">
                                          <Button
                                     color="primary"
                                     className="storage-folder-btn"
                                     onClick={e => this.onCreateFolderClick(e, true)}
                                   >
                                     Create
                                   </Button>
                                  </InputGroupAddon>
                                </InputGroup>
                              </PopoverBody>
                            </UncontrolledPopover>
                            <UncontrolledTooltip placement="top" target="create-folder" delay={0}>
                              Create Folder
                            </UncontrolledTooltip>
                              <UncontrolledDropdown id="upload">
                                <DropdownToggle
                                className="storage-btn btn-link" 
                                >
                              <i className="fas fa-cloud-upload-alt"></i>
                                </DropdownToggle>
                                <DropdownMenu
                                  className="dropdown-menu-arrow"
                                  right
                                >
                                  <DropdownItem
                                    onClick={this.toggleUpload}
                                  >
                                    <span id='Comments'>
                                      <i className="now-ui-icons files_paper mr-3" /> Files
                                    </span>
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={this.showFolderUpload}
                                  >
                                    <span id='Comments'>
                                      <i className="fas fa-folder mr-3"/> Folder
                                    </span>
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            <UncontrolledTooltip placement="top" target="upload" delay={0}>
                              Upload
                            </UncontrolledTooltip>
                            <input
                              type="file"
                              webkitdirectory=""
                              multiple=""
                              directory=""
                              ref={this.folderUploadRef} hidden
                              onChange={e => this.handleFolderUploadFiles(e, false)}
                              onClick={e => e.target.value = null}
                            />
                            <Modal
                              centered
                              className="upload-modal"
                              isOpen={this.state.showUploadModal}
                              toggle={this.toggleUpload}
                              backdrop="static"
                              returnFocusAfterClose={false}
                            >
                              <ModalHeader toggle={this.toggleUpload}>File Uploads</ModalHeader>
                              <ModalBody>
                                <FilePond
                                  name="fileupload"
                                  allowMultiple={true}
                                  maxParallelUploads={5}
                                  server={{
                                    process: this.filePondProcess
                                  }}
                                  onprocessfiles={() => {
                                    this.fetchStorageItems(this.state.currFolder, null, false)
                                  }}
                                >
                                </FilePond>
                              </ModalBody>
                            </Modal>
                            <Modal
                              centered
                              className="upload-modal"
                              isOpen={this.state.showFolderUploadModal}
                              toggle={this.toggleFolderUpload}
                              backdrop="static"
                              returnFocusAfterClose={false}
                              onOpened={() => {
                                this.createUploadFolders(this.state.currFolder)
                                this.filePond.processFiles()
                              }}
                            >
                              <ModalHeader toggle={this.toggleFolderUpload}>Folder Uploads</ModalHeader>
                              <ModalBody>
                                <FilePond ref={ref => this.filePond = ref}
                                  name="folderupload"
                                  files={this.state.folderUploadFiles}
                                  allowMultiple={true}
                                  server={{
                                    process: this.filePondProcess
                                  }}
                                  labelIdle=""
                                  maxParallelUploads={5}
                                  onprocessfiles={() => {
                                    this.fetchStorageItems(this.state.currFolder, null, false)
                                  }}
                                >
                                </FilePond>
                              </ModalBody>
                            </Modal>
                          </ButtonGroup>
                        </Col>
                       </Row>
                        </CardSubtitle>
                        <Row className="border-top"> 
                           <Col md="12" xs="12" className="textcenter">
                          <ButtonGroup className="chatLoading verticalAligntxt" style={{display:this.state.dispayload}}>
                          </ButtonGroup>
                      </Col>                             
                             </Row>  
                        {this.state.viewSelected === 1 && <div className="storagetitle px-3 border-top" >
                          <Row >
                            <Col md="7" xs="7" className="storagetitleright">
                              <a
                                href={() => false}
                                data-sort="null"
                                className="storage-title df-text-black"
                                data-label="Name"
                                onClick={e => this.sortBy(e, 'name')}
                                id="storage-label-name"
                              >
                                Name
                              </a>
                            </Col>
                            <Col md="2" xs="2" className="storagetitleright">
                              <a
                                href={() => false}
                                data-sort="null"
                                className="storage-title df-text-black"
                                data-label="Size"
                                onClick={e => this.sortBy(e, 'size')}
                                id="storage-label-size"
                              >
                                Size
                              </a>
                            </Col>
                            <Col md="3" xs="3">
                              <a
                                href={() => false}
                                data-sort="null"
                                className="storage-title df-text-black"
                                data-label="Last Modified"
                                onClick={e => this.sortBy(e, 'created')}
                                id="storage-label-created"
                              >
                                Last Modified
                              </a>
                            </Col>
                          </Row>
                        </div>}
                        {/* Split window first*/}
                        <CardBody className="border-top storage-content equalheight" onScroll={this.handleScroll}>
                          <StorageBody
                            isSideSplited={false}
                            splitscreen = {true}
                            myHomeFolders={this.state.myHomeFolders}         
                            files={this.state.files}
                            folders={this.state.folders}
                            showFilesModal={this.state.showFilesModal}
                            loadmoreFlag={this.state.loadmoreFlag}
                            nextPageToken={this.state.nextPageToken}
                            emptyRows={this.state.emptyRows}
                            fetchStorageItems={this.fetchStorageItems}
                            currFolder={this.state.currFolder}
                            viewSelected={this.state.viewSelected}
                            progressmsg={this.state.progressmsg}
                            fetchProgress={this.fetchProgress}
                            previewFile={this.previewFile}
                            itstrash={this.state.itstrash}
                            pasteFolder={this.pasteFolder}
                            selectMoveFile={this.selectMoveFile}
                            selectCopyFile={this.selectCopyFile}
                            renameFile={this.renameFile}
                            refreshstorage={this.refreshstorage}
                            // folderstatus={this.state.folderstatus}
                            sourceStorageId={this.state.sourceStorageId}
                            sourceRootFolder={this.state.sourceRootFolder}
                            storageDetail={this.getStorageDetail(this.state.sourceStorageId)}
                            folderstatus={false}
                            selectItem={false}
                            configArray={this.state.configArray}
                          />
                        </CardBody>
                        {this.state.nextPageToken === null && <Row>
                          <Col className="textcenter">
                          <span className="pageend">-- Page End --</span>
                          </Col>
                        </Row>}
                      </Card>
                    </Col>
                      
                    <Col xs={12} sm={12} md={12} lg={this.state.showPreview ? "6" : "6"} xl={this.state.showPreview ? "6" : "6"} className="storage-side-pane-col">
                     <Card className="storage-content-card storage-card">
                       <CardSubtitle className="clearfix px-2">
                       <Row>
                       <Col xs={12} md="9">
                          <ButtonGroup className="">
                             <Button
                             className="storage-btn"
                             size="sm"
                             color="link"   
                             id='refresh'
                             onClick={e => this.refreshstorage(e, 'true')}
                             >
                             <i className="fas fa-sync-alt"></i>                              
                            </Button>
                           <UncontrolledTooltip placement="top" target="refresh" delay={0}>
                             Reload
                           </UncontrolledTooltip>
                           <Breadcrumb listClassName="bg-transparent storage-nav-breadcrumb storagetxt" listTag="div">
                           {this.state.navigationsSide}
                         </Breadcrumb> 
                           </ButtonGroup>                           
                       </Col>  
                       <Col xs={12} md="2" className={this.state.itstrash ? "fa-disabled" : ""}>
                         <ButtonGroup className="">
                            <Button
                             className="storage-btn"
                             size="sm"
                             color="link"
                             id='create-folder-split'
                             onClick={this.toggleFolderCreateSplit}
                           >
                             <i className="fas fa-folder-plus font15"></i>
                           </Button>
                           <UncontrolledPopover
                             placement="bottom"
                             target="create-folder-split"
                             className="popover-primary"
                             trigger="legacy"
                           >
                             <PopoverHeader>Create Folder
                             </PopoverHeader>
                             <PopoverBody>
                               <InputGroup>
                                 <Input
                                   placeholder="Folder Name"
                                   name="folderToBeCreate"
                                   value={this.state.folderToBeCreate}
                                   onChange={this.handleInputChange} />
                                 <InputGroupAddon addonType="append">
                                   <Button
                                     color="primary"
                                     className="storage-folder-btn"
                                     onClick={e => this.onCreateFolderClick(e, true)}
                                   >
                                     Create
                                   </Button>
                                 </InputGroupAddon>
                               </InputGroup>
                             </PopoverBody>
                           </UncontrolledPopover>
                           <UncontrolledTooltip placement="top" target="create-folder" delay={0}>
                             Create Folder
                           </UncontrolledTooltip>
                          
                           <UncontrolledDropdown id="upload">
                                <DropdownToggle
                                className="storage-btn btn-link">
                                 <i className="fas fa-cloud-upload-alt"></i>
                               </DropdownToggle>
                               <DropdownMenu
                                 className="dropdown-menu-arrow"
                                 right
                               >
                                 <DropdownItem
                                   onClick={this.toggleSplitUpload}
                                 >
                                   <span id='Comments'>
                                     <i className="now-ui-icons files_paper mr-3" /> Files
                                   </span>
                                 </DropdownItem>
                                 <DropdownItem
                                   onClick={this.showSplitFolderUpload}
                                 >
                                   <span id='Comments'>
                                     <i className="fas fa-folder mr-3"/> Folder
                                   </span>
                                 </DropdownItem>
                               </DropdownMenu>
                             </UncontrolledDropdown>
                           <UncontrolledTooltip placement="top" target="upload" delay={0}>
                             Upload
                           </UncontrolledTooltip>
                           <input
                             type="file"
                             webkitdirectory=""
                             multiple=""
                             directory=""
                             ref={this.splitFolderUploadRef} hidden
                             onChange={e => this.handleFolderUploadFiles(e, true)}
                             onClick={e => e.target.value = null}
                           />
                           <Modal
                             centered
                             className="upload-modal"
                             isOpen={this.state.showSplitUploadModal}
                             toggle={this.toggleSplitUpload}
                             backdrop="static"
                             returnFocusAfterClose={false}
                           >
                             <ModalHeader toggle={this.toggleSplitUpload}>File Uploads</ModalHeader>
                             <ModalBody>
                              <FilePond
                                name="fileupload-split"
                                allowMultiple={true}
                                // maxFiles={10}
                                server={{
                                  process: this.filePondSplitProcess
                                }}
                                maxParallelUploads={5}
                                onprocessfiles={() => {
                                  this.fetchStorageItems(this.state.currFolderSide, null, true)
                                }}
                              >
                              </FilePond>
                             </ModalBody>
                           </Modal>
                           <Modal
                             centered
                             className="upload-modal"
                             isOpen={this.state.showSplitFolderUploadModal}
                             toggle={this.toggleSplitFolderUpload}
                             backdrop="static"
                             returnFocusAfterClose={false}
                             onOpened={() => {
                              this.createUploadFolders(this.state.currFolderSide)
                               this.filePond.processFiles()
                             }}
                           >
                             <ModalHeader toggle={this.toggleSplitFolderUpload}>Folder Uploads</ModalHeader>
                             <ModalBody>
                              <FilePond ref={ref => this.filePond = ref}
                                name="folderupload-split"
                                files={this.state.folderUploadFiles}
                                allowMultiple={true}
                                server={{
                                  process: this.filePondSplitProcess
                                }}
                                labelIdle=""
                                maxParallelUploads={5}
                                onprocessfiles={() => {
                                  this.fetchStorageItems(this.state.currFolderSide, null, true)
                                }}
                              >
                               </FilePond>
                             </ModalBody>
                           </Modal>
                         </ButtonGroup>
                       </Col>
                      </Row>
                       </CardSubtitle>
                       <Row className="border-top"> 
                          <Col md="12" xs="12" className="textcenter">
                         <ButtonGroup className="chatLoading verticalAligntxt" style={{display:this.state.dispayload}}>
                         </ButtonGroup>
                     </Col>                             
                            </Row>  
                            {this.state.viewSelected === 1 && <div className="storagetitle px-3 border-top" >
                         <Row >
                           <Col md="7" xs="7" className="storagetitleright">
                             <a
                              href={() => false}
                               data-sort="null"
                               className="storage-title df-text-black"
                               data-label="Name"
                               onClick={e => this.sortBy(e, 'name')}
                               id="storage-label-name"
                             >
                               Name
                             </a>
                           </Col>
                           <Col md="2" xs="2" className="storagetitleright">
                             <a
                               href={() => false}
                               data-sort="null"
                               className="storage-title df-text-black"
                               data-label="Size"
                               onClick={e => this.sortBy(e, 'size')}
                               id="storage-label-size"
                             >
                               Size
                             </a>
                           </Col>
                           <Col md="3" xs="3">
                             <a
                               href={() => false}
                               data-sort="null"
                               className="storage-title df-text-black"
                               data-label="Last Modified"
                               onClick={e => this.sortBy(e, 'created')}
                               id="storage-label-created"
                             >
                               Last Modified
                               {/* <i className="fas fa-sort ml-2"></i> */}
                             </a>
                           </Col>
                         </Row>
                       </div>}
                       {/* split window second */}
                       <CardBody className="border-top storage-content equalheight" onScroll={this.handleScroll}>
                          <StorageBody
                            isSideSplited={true}
                            splitscreen = {true}
                            files={this.state.filesSide}
                            folders={this.state.foldersSide}
                            emptyRows={this.state.emptyRows}
                            loadmoreFlag={this.state.loadmoreFlag}
                            showFilesModal={this.state.showFilesModal}
                            nextPageToken={this.state.nextPageToken}
                            myHomeFolders={this.state.myHomeFolders}
                            fetchStorageItems={this.fetchStorageItems}
                            currFolder={this.state.currFolderSide}
                            viewSelected={this.state.viewSelected}
                            progressmsg={this.state.progressmsg}
                            itstrash={this.state.itstrash}
                            fetchProgress={this.fetchProgress}
                            previewFile={this.previewFile}
                            renameFile={this.renameFile}
                            pasteFolder={this.pasteFolder}
                            selectCopyFile={this.selectCopyFile}
                            selectMoveFile={this.selectMoveFile}
                            refreshstorage={this.refreshstorage}
                            sourceStorageId={this.state.sourceStorageId}
                            sourceRootFolder={this.state.sourceRootFolder}
                            storageDetail={this.getStorageDetail(this.state.sourceStorageId)}
                            folderstatus={false}
                            selectItem={false}
                            configArray={this.state.configArray}
                          />
                       </CardBody>
                        {this.state.nextPageToken === null && <Row>
                          <Col className="textcenter">
                          <span className="pageend">-- Page End --</span>
                          </Col>
                        </Row>}
                     </Card>
                   </Col>
                   </Row>
                   </div>
                   </Col>
                   }
                  {/* show one file screen & preview screen */}
                  {!this.state.showSplit &&
                    <Col xs={12} md={12} lg={this.state.showPreview ? "6" : "9"} xl={this.state.showPreview ? "6" : "9"} className="storage-side-pane-col">
                      <Card className="storage-content-card storage-card">
                        <CardSubtitle className="clearfix px-2">
                        <Row>
                        <Col xs={12} md="9" >
                           <ButtonGroup className="">
                              <Button
                              className="storage-btn"
                              size="sm"
                              color="link"   
                              id='refresh'
                              onClick={e => this.refreshstorage(e, 'false')}
                            >
                              <i className="fas fa-sync-alt"></i>                              
                             </Button>
                            <UncontrolledTooltip placement="top" target="refresh" delay={0}>
                              Reload
                            </UncontrolledTooltip>
                            <Breadcrumb listClassName="bg-transparent storage-nav-breadcrumb storagetxt" listTag="div">
                            {this.state.navigations}
                          </Breadcrumb> 
                            </ButtonGroup>                           
                        </Col>  
                  
                        <Col xs={12} md="2" className={this.state.itstrash ? "fa-disabled" : ""}>
                          <ButtonGroup className="">
                             <Button
                              className="storage-btn"
                              size="sm"
                              color="link"
                              id='create-folder'
                              onClick={this.toggleFolderCreate}
                            >
                              <i className="fas fa-folder-plus" style={{fontSize:"15px"}}></i>
                            </Button>
                            <UncontrolledPopover
                              placement="bottom"
                              target="create-folder"
                              className="popover-primary"
                              trigger="legacy"
                            >
                              <PopoverHeader>Create Folder
                              </PopoverHeader>
                              <PopoverBody>
                                <InputGroup>
                                  <Input
                                    placeholder="Folder Name"
                                    name="folderToBeCreate"
                                    value={this.state.folderToBeCreate}
                                    onChange={this.handleInputChange} />
                                  <InputGroupAddon addonType="append">
                                    <Button
                                      className="storage-btn"
                                      size="sm"
                                      color="link"
                                      id='create-folder'
                                      onClick={e => this.onCreateFolderClick(e)}
                                    > Create
                                    </Button>
                                  </InputGroupAddon>
                                </InputGroup>
                              </PopoverBody>
                            </UncontrolledPopover>
                            <UncontrolledTooltip placement="top" trigger="hover" target="create-folder" delay={0}>
                              Create Folder
                            </UncontrolledTooltip>
                            <UncontrolledDropdown id="upload" trigger="legacy">
                                <DropdownToggle
                                className="storage-btn btn-link" 
                                >
                                  <i className="fas fa-cloud-upload-alt"></i>
                                </DropdownToggle>
                                <DropdownMenu
                                  className="dropdown-menu-arrow"
                                  right
                                >
                                  <DropdownItem
                                    onClick={this.toggleUpload}
                                  >
                                    <span id='Comments'>
                                      <i className="now-ui-icons files_paper mr-3" /> Files
                                    </span>
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={this.showFolderUpload}
                                  >
                                    <span id='Comments'>
                                      <i className="fas fa-folder mr-3"/> Folder
                                    </span>
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            <UncontrolledTooltip placement="top" trigger="hover" target="upload" delay={0}>
                              Upload
                            </UncontrolledTooltip>
                            <input
                              type="file"
                              webkitdirectory=""
                              multiple=""
                              directory=""
                              ref={this.folderUploadRef} hidden
                              onChange={e => this.handleFolderUploadFiles(e, false)}
                              onClick={e => e.target.value = null}
                            />
                            <Modal
                              centered
                              className="upload-modal"
                              isOpen={this.state.showUploadModal}
                              toggle={this.toggleUpload}
                              backdrop="static"
                              returnFocusAfterClose={false}
                            >
                              <ModalHeader toggle={this.toggleUpload}>File Uploads</ModalHeader>
                              <ModalBody>
                                <FilePond
                                  name="fileupload"
                                  allowMultiple={true}
                                  // maxFiles={10}
                                  maxParallelUploads={5}
                                  server={{
                                    process: this.filePondProcess
                                  }}
                                  onprocessfiles={() => {
                                    this.fetchStorageItems(this.state.currFolder, null, false)
                                  }}
                                >
                                </FilePond>
                              </ModalBody>
                            </Modal>
                            <Modal
                              centered
                              className="upload-modal"
                              isOpen={this.state.showFolderUploadModal}
                              toggle={this.toggleFolderUpload}
                              backdrop="static"
                              returnFocusAfterClose={false}
                              onOpened={() => {
                                this.createUploadFolders(this.state.currFolder)
                                this.filePond.processFiles()
                              }}
                            >
                              <ModalHeader toggle={this.toggleFolderUpload}>Folder Uploads</ModalHeader>
                              <ModalBody>
                                <FilePond ref={ref => this.filePond = ref}
                                  name="folderupload"
                                  files={this.state.folderUploadFiles}
                                  allowMultiple={true}
                                  // maxFiles={10}
                                  maxParallelUploads={5}
                                  server={{
                                    process: this.filePondProcess
                                  }}
                                  labelIdle=""
                                  onprocessfiles={() => {
                                    this.fetchStorageItems(this.state.currFolder, null, false)
                                  }}
                                >
                                </FilePond>
                              </ModalBody>
                            </Modal>
                          </ButtonGroup>
                        </Col>
                       </Row>
                        </CardSubtitle>
                        <Row className="border-top"> 
                           <Col md="12" xs="12" className="textcenter">
                          <ButtonGroup className="chatLoading verticalAligntxt" style={{display:this.state.dispayload}}>
                                  <Badge color="info"> {this.state.statemsg}... </Badge>
                          </ButtonGroup>
                      </Col>                             
                             </Row>  
                             {this.state.viewSelected === 1 && <div className="storagetitle px-3 border-top" >
                          <Row >
                            <Col md="7" xs="7" className="storagetitleright">
                              <a
                                href={() => false}
                                data-sort="null"
                                className="storage-title df-text-black"
                                data-label="Name"
                                onClick={e => this.sortBy(e, 'name')}
                                id="storage-label-name"
                              >
                                Name
                              </a>
                            </Col>
                            <Col md="2" xs="2" className="storagetitleright">
                              <a
                                href={() => false}
                                data-sort="null"
                                className="storage-title df-text-black"
                                data-label="Size"
                                onClick={e => this.sortBy(e, 'size')}
                                id="storage-label-size"
                              >
                                Size
                              </a>
                            </Col>
                            <Col md="3" xs="3">
                              <a
                                href={() => false}
                                data-sort="null"
                                className="storage-title df-text-black"
                                data-label="Last Modified"
                                onClick={e => this.sortBy(e, 'created')}
                                id="storage-label-created"
                              >
                                Last Modified
                              </a>
                            </Col>
                          </Row>
                        </div>}
                        {/* handle scroll event */}
                        <CardBody className="border-top storage-content equalheight" onScroll={this.handleScroll}>
                          <StorageBody        
                            isSideSplited={false}                  
                            files={this.state.files}
                            folders={this.state.folders}
                            emptyRows={this.state.emptyRows}
                            splitscreen = {false}
                            loadmoreFlag={this.state.loadmoreFlag}
                            showFilesModal={this.state.showFilesModal}
                            nextPageToken={this.state.nextPageToken}
                            myHomeFolders={this.state.myHomeFolders}         
                            fetchStorageItems={this.fetchStorageItems}
                            currFolder={this.state.currFolder}
                            viewSelected={this.state.viewSelected}
                            progressmsg={this.state.progressmsg}
                            fetchProgress={this.fetchProgress}
                            previewFile={this.previewFile}
                            renameFile={this.renameFile}
                            toggleShowFiles={this.toggleShowFiles}
                            itstrash={this.state.itstrash}
                            selectMoveFile={this.selectMoveFile}
                            refreshstorage={this.refreshstorage}
                            sourceStorageId={this.state.sourceStorageId}
                            sourceRootFolder={this.state.sourceRootFolder}
                            storageDetail={this.getStorageDetail(this.state.sourceStorageId)}
                            folderstatus={false}
                            configArray={this.state.configArray}
                          />
                        </CardBody>
                        {this.state.nextPageToken === null && <Row>
                          <Col className="textcenter">
                          <span className="pageend">-- Page End --</span>
                          </Col>
                        </Row>}
                      </Card>
                    </Col>
                  }
                   {/* show preview screen */}
                    {this.state.showPreview &&
                    <Col xs={12} sm={12} md={12} lg={3} xl={3} className="storage-content-pane-col" >
                    <Card className="storage-content-card storage-card">
                        <CardSubtitle className="clearfix px-2">
                        <Row>
                            <Col xs={12} sm={8}>
                            <div className="chartvariable font650">
                                <span title={this.state.onlyfilename} className="overflowStyle">{this.state.onlyfilename}</span>
                            </div> 
                            </Col> 

                            <Col xs={12} sm={4}>
                            <div className="chartvariable floatright">
                                {this.state.fileSize !== "--" 
                                ?
                                <i className="fas fa-download previewstyle"  onClick={e => this.downloadparticularFiles(this.state.fileName,this.state.sourceStorageId,this.state.sourceRootFolder)}></i>
                                :""}
                            </div>
                            </Col> 
                        </Row>
                        {this.state.fileType === "csv"&&<hr></hr>}
                        {this.state.fileType === "csv"&&
                        <Row>
                            <Col xs={12} sm={4}>
                        <label>Choose File Delimiter</label>
                        </Col>
                        <Col xs={12} sm={8}>
                        <Select name="delimiterName"
                                value={delimiteroptions.filter(item => item.value === this.state.delimiter)}
                                options={delimiteroptions} onChange={this.handleChangeSelectDelimiter} noValidate />
                        </Col>
                        </Row>}
                        </CardSubtitle>
                        <CardBody className="border-top preview-content ">
                        <Row>
                        <Col xs={12} md="12">
                        <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>  
                         {this.state.fileType !== "csv" &&<div>

                        {(this.state.fileType === "jpeg" || this.state.fileType === "jpg" || 
                        this.state.fileType === "png" || this.state.fileType === "PNG")&&
                        <img src={this.state.myContent} alt="NoImage"/>
                        }
                                    {(this.state.fileType === "pdf" && this.state.showPdfViewer === true) &&
                                      <div>
                                        {this.state.myContent !== "" &&
                                          <div className="pdf-div">
                                            <PdfViewer myContent={this.state.myContent}></PdfViewer>
                                          </div>}
                                      </div>
                                    }


                                    {(this.state.fileType === "xlsx" || this.state.fileType === "xls") &&
                                      <div>
                                        <Tabs onChange={(tabId) => {
                                          this.setState({
                                            activeTab: tabId,
                                          })
                                        }}>
                                          <div className="proj-search">
                                            <TabList>
                                              <Row>
                                                <div className="col-12 proj-tabs">
                                                  <label><code>Sheets :</code></label>{this.state.sheetName.map((item, index) => (
                                                    <Tab tabFor={item} className="adddatatab" onClick={e => this.getTabData(item)}> {item}</Tab>
                                                  ))
                                                  }
                                                </div>
                                              </Row>
                                            </TabList>
                                          </div>
                                          <CardBody>
                                            <Scrollbars autoHeight autoHeightMin={this.state.sheight - 200}>
                                              <TabPanel tabId={this.state.activeExcel}>
                                                <HotTable
                                                  root="hot"
                                                  ref={this.hotTableComponent}
                                                  data={this.state.hotSettings}
                                                  colHeaders={true}
                                                  readOnly={this.state.readonlyTable}
                                                  rowHeaders={true}
                                                  comments={true}
                                                  search={true}
                                                  dropdownMenu={this.state.contextMenuTable}
                                                  multiColumnSorting={true}
                                                  filters={true}
                                                  settings={this.hotformula}
                                                  manualRowMove={true}
                                                  contextMenu={this.state.contextMenuTable}
                                                  licenseKey={HandsonTableKey}
                                                  stretchH="all"
                                                  renderer={this.state.rowheader === true ? this.renderer : ""}
                                                />
                                              </TabPanel>
                                            </Scrollbars>

                                          </CardBody>
                                        </Tabs>

                                      </div>
                                    }



                        {(this.state.fileType === "py" || this.state.fileType === "log")&&
                        <p className="othercontentpara">
                            {this.state.myContent.split("\n").map((i,key) => {
                                return <div>{i}</div>;
                            })}
                        </p>
                        }
                        {this.state.fileType === "ipynb" &&
                        <div id="notebookDiv">
                          <td className="notebookdivwidth" dangerouslySetInnerHTML={{__html: this.state.myContent}} />
                          </div>
                        }
                               
                              {(this.state.fileType === "others") &&
                        <p className="othercontentpara">
                                {this.state.myContent}
                        </p>
                        } 
                        </div> }
                         {this.state.fileType === "csv"  &&<div>
                         {this.state.NoData === false &&
                                    <HotTable
                                      root="hot"
                                      ref={this.hotTableComponent}
                                      data={this.state.hotSettings}
                                      colHeaders={true}
                                      readOnly={this.state.readonlyTable}
                                      rowHeaders={true}
                                      comments={true}
                                      search={true}
                                      dropdownMenu={this.state.contextMenuTable}
                                      multiColumnSorting={true}
                                      filters={true}
                                      settings={this.hotformula}
                                      manualRowMove={true}
                                      contextMenu={this.state.contextMenuTable}
                                      licenseKey={HandsonTableKey}
                                      stretchH="all"
                                      renderer={this.state.rowheader === true ? this.renderer : ""}
                                    />
                                  }


                            {/* <JsonToTable json={this.state.myContent} key={uuidv4()}/> */}
                            <ReactPaginate
                           previousLabel={<i className="fa fa-angle-double-left" />}
                           nextLabel={<i className="fa fa-angle-double-right" />}
                          breakLabel={'...'}
                          breakClassName={'break-me'}
                          pageCount={this.state.totalPages}
                          forcePage={this.state.activePage - 1}
                          onPageChange={this.handlePageClick}
                          containerClassName={'pagination'}
                          subContainerClassName={'pages pagination'}
                          activeClassName="active"
                          pageClassName="liPaginate"
                          previousClassName="preStyle"
                          nextClassName = "nexStyle"
                        />
                          </div>
                          }
                       </Scrollbars>
                     
                        </Col>
                        </Row>                        
                        </CardBody>
                        </Card>
                    </Col>
                    }
                  </Row>
                </CardBody>
              </Scrollbars>
              <CardFooter className="storage-btn storage-side-pane-footer border-top storagetxt footer_991" style={{cursor:'pointer',position:'sticky',left:0,bottom:0,right:0}}
                        onClick={e => {this.getTrashFile('trash/')}}
                        >
                        <i className="fas fa-trash-alt"></i> Trash
                        </CardFooter>
              </Card>
            </Col>
          </Row>
          <Modal
            centered
            className="upload-modal"
            isOpen={this.state.showViewFilesModal}
            toggle={this.toggleViewFiles}
            backdrop="static"
            returnFocusAfterClose={false}
          >
            <ModalHeader toggle={this.toggleViewFiles}>View Files</ModalHeader>
            <ModalBody>
              <p>View</p>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" >Cancel</Button>{' '}
            </ModalFooter>
          </Modal>
          <Modal
            centered
            className="upload-modal"
            isOpen={this.state.showFilesModal}
            toggle={this.toggleShowFiles}
            backdrop="static"
            returnFocusAfterClose={false}
          >
            <ModalHeader toggle={this.toggleShowFiles}>Select Folder</ModalHeader>
            <ModalBody>
              <Col xs={12} md="12">
                <Row>
                  <div className="col">
                    <Breadcrumb listClassName="bg-transparent storage-nav-breadcrumb storagetxt" listTag="div">
                      {this.state.navigations}
                    </Breadcrumb>
                  </div>
                </Row>
              </Col>
              <Row className="border-top">
              <Col sm={12}  md={3} xl={3} lg={3} className="selectfolderborder">
              <div>
                                    {this.state.configArray.map((item,index) => (<div className="card-plain">
                                                  <CardHeader role="tab" onMouseEnter={e => { this.handleMouseHover(item.name) }}
                                      onMouseLeave={e=>this.handleMouseLeave(e)}
                                      >
                                                    <a
                                                      aria-expanded={this.state.openedCollapses.includes(
                                                        "collapseStorage_Popup"+index
                                                      )}
                                                      href="#pablo"
                                                      data-parent="#accordion"
                                                      data-toggle="collapse"
                                                      onClick={e => {
                                                        e.preventDefault();
                                                        this.collapsesToggle("collapseStorage_Popup"+index);
                                                      }}
                                                    >
                                                      <Row className={item.name === this.state.activeConfigPath ?"activeStorageConfig":"" }>
                                                        <Col xs={item.name === default_StorageName?"12":"8"}>
                                                          {item.platformDefault ?
                                                            <div title={item.name} className="overflowStyle bucketnamestyle" onClick={e => {this.onBucketNameClick_Popup(item,item.name)}}>
                                                              <img src={provisionerTypeLogo(undefined)} className="imgStorageList" alt="aws"/>
                                                              <span className="pl-2">{default_LabelStorageName}</span>
                                                            </div> :
                                                            <div title={item.name} className="overflowStyle bucketnamestyle" onClick={e => {this.onBucketNameClick_Popup(item,item.name)}}>
                                                              <img src={provisionerTypeLogo(item.provisionerType)} className="imgStorageList" alt="aws"/>
                                                              <span className="pl-2">{item.name}</span>
                                                            </div>
                                                          }
                                                        </Col>
                                                        {item.name !== default_StorageName && <Col xs="2">
                                                        <i className="now-ui-icons arrows-1_minimal-down defaultstrg"/>
                                                        </Col>}

                                
                                                      </Row>
                                                    </a>
                                                    
                                                    
                                                  </CardHeader>
                                                  <Collapse
                                                    role="tabpanel"
                                                    isOpen={this.state.openedCollapses.includes(
                                                      "collapseStorage_Popup"+index
                                                    )}
                                                  >
                                                    {item.storageConfig !== null  && item.storageConfig.bucketStorages.map((cItem, index) => (<CardBody className="p-2">
                                                    <Row>
                                                        <Col lg="12">
                                                        <span style={{marginLeft:17}} className={this.state.selectedStorage === cItem.bucketName ? "activeBucket" : ""} onClick={e => {this.onBucketNameClick_Popup(item,cItem)}}>
                                                        <img src={awsbucket} className="imgBucket" alt="aws"/><span title={cItem.bucketName} className="bucketListView">{cItem.bucketName}</span></span>
                                                  
                                                        </Col>
                                                      </Row>
                                                    </CardBody>))}
                                                  </Collapse>
                                                                                       

                                                </div>))}
                                  {/* </Scrollbars>    */}
                          </div>
              </Col>
              <Col  sm={12}  md={9} xl={9} lg={9}>
              <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
              {/* copy and move storage popup */}
              <CardBody className="storage-content equalheight" onScroll={this.handleScroll}>

            <StorageBody                          
                           isSideSplited={false}                  
                           files={this.state.files}
                           folders={this.state.folders}
                           emptyRows={this.state.emptyRows}
                           splitscreen = {false}
                           loadmoreFlag={this.state.loadmoreFlag}
                           showFilesModal={this.state.showFilesModal}
                           nextPageToken={this.state.nextPageToken}
                           myHomeFolders={this.state.myHomeFolders}         
                           fetchStorageItems={this.fetchStorageItems}
                           currFolder={this.state.currFolder}
                           viewSelected={this.state.viewSelected}
                           progressmsg={this.state.progressmsg}
                           fetchProgress={this.fetchProgress}
                           previewFile={this.previewFile}
                           renameFile={this.renameFile}
                           selectMoveFile={this.selectMoveFile}
                           sourceFolder={this.state.sourceFolder}
                           showAllFolders={this.state.showAllFolders}     
                           itstrash={this.state.itstrash}
                           sourceStorageId={this.state.sourceStorageId}
                           sourceRootFolder={this.state.sourceRootFolder}
                           storageDetail={this.getStorageDetail(this.state.sourceStorageId)}
                           folderstatus={false}
                           configArray={this.state.configArray}
                         />
                         </CardBody>
                        {this.state.nextPageToken === null && <Row>
                          <Col style={{textAlign: "center"}}>
                          <span style={{fontSize: 13,color: "#8c8b8b"}}>-- Page End --</span>
                          </Col>
                        </Row>}
                         </Scrollbars>
              </Col>
            </Row>
            
            </ModalBody>
            <ModalFooter>
              <br></br>
              <Col xs={12} md="12">
                <Row>
                  <div className="col text-left">
                    {this.state.showbutton === "Move" &&
                      <Col className="movepopHint">
                        <span className="notepopHint">Note: </span><span> Update reference of 'Moved' folder/file in Project</span>
                      </Col>
                    }&nbsp;
                  </div>

                  <div className="col text-right">
                    <Button color="secondary" onClick={e => this.cancelMove()}>Cancel</Button>{' '}
                    {this.state.showbutton === "Move" &&
                      <Button color="primary" onClick={e => this.moveFolder()} >Move</Button>
                    }&nbsp;
                    {this.state.showbutton === "Copy" &&
                      <Button color="primary" onClick={e => this.copyFolder()} >Copy</Button>
                    }&nbsp;

                  </div>
                </Row>
              </Col>
            </ModalFooter>
          </Modal>
          <Modal
            id="errorDiv"
            centered
            className="upload-modal"
            isOpen={this.state.showStorageConfig}
            toggle={this.toggleStorageConfig}
            backdrop="static"
            returnFocusAfterClose={false}
          >
            <ModalHeader toggle={this.toggleStorageConfig}>{this.state.editId === "" ? "New" : "Update"} Configuration</ModalHeader>
            <ModalBody>
              <hr className="hrStyle" />
              <Col xs={12} md="12">


                <CardBody>
                  {this.state.errorSubmitted &&
                    <div style={styles.errorBox}>
                      <span style={styles.error}>{this.state.errorMessage}</span>
                    </div>
                    }
                    <Row xs="12" className="strgdetails">
                    <Col lg="12">
                    <code><b>Storage Basic Details</b></code>
                    <br />
                    <Card className="card-contributions strgcard" >
                    <CardBody>
                    <Row className="icon-examples strgrow">
                        <Col lg="6"> 
                        <Label md="6">Name *</Label>
                        <FormGroup>
                        <Input
                          className="form-control inputBoxStyle"
                          placeholder="Name"
                          name="name"
                          value={this.state.name}
                          type="text"
                          onChange={this.handleChange}/>
                        </FormGroup>
                        </Col>

                        <Col lg="6"> 
                        <Label md="12">Description</Label>
                        <FormGroup>
                        <Input
                            className="form-control descrip inputBoxStyle"
                            placeholder="Description"
                            name="description"
                            value={this.state.description}
                            type="textarea"
                            onChange={this.handleChange} noValidate />
                        </FormGroup>
                        </Col>
                    </Row>

                    <Row className="icon-examples strgrow">  
                        <Col lg="5">
                      <Label md="5">Provisioner</Label>
                      <FormGroup>
                        <Select className="selectMargin"
                            value={this.state.provisionerNames.filter(item => item.value === this.state.provisionerId)}
                            options={this.state.provisionerNames} onChange={this.handleChangeTypes} />
                            </FormGroup>
                        </Col>  

                        <Col md="7" className="provisionerselect">
                          <Row>
                              
                            {this.state.editId !== "" && <Col>
                                <FormGroup className="provisionermargin">
                                <Label>Storage Status</Label>&nbsp; &nbsp; &nbsp;<Switch onChange={(el, state) => this.handleSwitchStorageStaus(el, state)} 
                                value={this.state.isStorageStatus} name='storageStatus' 
                                data-on-color="secondary" 
                                onText="Yes"
                                offText="No"
                                data-off-color="default"/>
                              </FormGroup>
                            </Col>}
                            
                            <Col>
                            <FormGroup className="provisionermargin">
                                <Label>Primary </Label>&nbsp; &nbsp;&nbsp; &nbsp;<Switch onChange={(el, state) => this.handleSwitch(el, state)} 
                                value={this.state.isStoragePrimary} name='write access' 
                                data-on-color="secondary" 
                                onText="Yes"
                                offText="No"
                                data-off-color="default"/>
                              </FormGroup>
                            </Col>
                          </Row>

                    </Col>
                    </Row>
                        </CardBody>
                      </Card>
                      </Col>

                    <Col lg="12">
                      <Button
                        size="sm"
                        className="df-btn-info"
                        onClick={e => this.OpenConfigureBucketes()}
                      >
                        <i className="fas fa-code-branch"></i>
                        &nbsp; Buckets
                      </Button>
                      <br />
                      <Card className="card-contributions" style={{ marginTop: 10 }}><CardBody>

                        <Row>
                          <table
                            className="table table-bordered table-hover"
                            id="tab_logic"
                          >
                            <thead>
                              <tr>
                                <th className="text-center"> # </th>
                                <th className="text-center"> Bucket Name </th>
                                <th className="text-center"> Primary </th>
                                <th className="text-center"> Read Only </th>
                                <th />
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.SelectedBucketList.map((item, idx) => (
                                <tr id="addr0" key={idx} style={{ fontSize: "14px" }}>
                                  <td style={{ textAlign: "center" }}>{idx + 1}</td>
                                  <td>
                                    <img src={awsbucket} className="imgBucket" alt="aws" /><span style={{ marginLeft: 5 }}>{this.state.SelectedBucketList[idx].bucketName}</span>
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <FormGroup>
                                      <input
                                        type="radio"
                                        name="primary"
                                        checked={this.state.SelectedBucketList[idx].primary}
                                        onChange={this.handleChangeBucket(idx)}
                                      />
                                    </FormGroup>
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        name="readOnly"
                                        checked={this.state.SelectedBucketList[idx].readOnly}
                                        onChange={this.handleChangeBucket(idx)}
                                      />
                                    </FormGroup>
                                  </td>
                                  <td className="removeIconstorage">
                                    <i onClick={this.handleRemoveSpecificRow(idx)} className="far fa-times-circle text-red"></i>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                        </Row>


                      </CardBody>
                      </Card>
                    </Col>

                  </Row>
                  <hr />

                  <Row style={{ float: "right" }}>
                    <Col lg="6">
                      <FormGroup>
                        <Button
                          color="secondary"
                          size="sm"
                          type="submit"
                          onClick={this.toggleStorageConfig}
                        >
                          Cancel
                        </Button>
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <Button
                          color="primary"
                          size="sm"
                          type="submit"
                          onClick={e => this.AddNewStorageConfig(e)}
                        >
                          {this.state.editId === "" ? "Create" : "Update"}
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>

              </Col>
            </ModalBody>
          </Modal>
          <Modal
            id="errorDiv"
            centered
            className="bucket-modal"
            isOpen={this.state.showStorageBucketList}
            toggle={this.toggleStorageBucketList}
            backdrop="static"
            returnFocusAfterClose={false}
          >
            <ModalHeader toggle={this.toggleStorageBucketList}>Buckets</ModalHeader>
            <ModalBody>
              <hr className="hrStyle" />
              <Col xs={12} md="12">

                <Row xs="12">
                  <Col lg="12">
                    <br />

                    <table
                      className="table"
                      id="tab_logic"
                    >
                      <thead>
                        <tr>
                          <th className=" thWidthforSelect"> <FormGroup>
                            <input
                              type="checkbox"
                              name="primary"
                              checked={this.state.SelectAllFlag}
                              onChange={this.handleSelectAll_CloudBucketList()}
                              className="form-control"
                            />
                          </FormGroup>
                          </th>
                          <th className=""> Bucket Name </th>
                          <th className=""> Date Created </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.CloudBucketList.map((item, idx) => (
                          <tr id="addr0" key={idx} className="bucketRowDesign">
                            <td>
                              <FormGroup>
                                <input
                                  type="checkbox"
                                  name="chooseBucketFlag"
                                  checked={this.state.CloudBucketList[idx].chooseBucketFlag}
                                  onChange={this.handleSelect_CloudBucketList(idx)}
                                  className="form-control"
                                />
                              </FormGroup>
                            </td>
                            <td>
                              <img src={awsbucket} className="imgBucket" alt="aws" /><span style={{ marginLeft: 5 }}>{this.state.CloudBucketList[idx].bucketName}</span>
                            </td>

                            <td>
                              <span>{item.dateCreated !== null ? moment.utc(item.dateCreated).local().format('MMM DD, YYYY hh:mm A') : ""}</span>
                            </td>

                          </tr>
                        ))}

                      </tbody>
                    </table>
                  </Col>


                </Row>
                <hr />

                <Row style={{ float: "right" }}>
                  <Col lg="6">
                    <FormGroup>
                      <Button
                        color="secondary"
                        size="sm"
                        type="submit"
                        onClick={this.toggleStorageBucketList}
                      >
                        Cancel
                      </Button>
                    </FormGroup>
                  </Col>
                  <Col lg="6">
                    <FormGroup>
                      <Button
                        color="primary"
                        size="sm"
                        type="submit"
                        onClick={e => this.SaveChooseBucketList(e)}
                      >
                        Save
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>

              </Col>
            </ModalBody>
          </Modal>
          <Modal
            centered
            className=""
            style={{ width: "31%" }}
            isOpen={this.state.showConfirmationCopyMove}
            toggle={this.toggleConfirmationCopyMove}
            backdrop="static"
            returnFocusAfterClose={false}
          >
            <ModalHeader toggle={this.toggleConfirmationCopyMove}>Already exists&nbsp;<i className="fas fa-exclamation"></i></ModalHeader>
            <ModalBody>
              <Col xs={12} md="12">
                <Row xs="12">
                  <Col lg="12">
                    <span>Do you want to  <b><i>{this.state.modeTransfer.toLowerCase()}</i></b> with <b><i>new name?</i></b></span>
                  </Col>
                </Row>

                <Row xs="12">
                  <Col lg="12">
                    <Input
                      placeholder="New Name"
                      name="renameNewValue"
                      className="inputRenameDesign"
                      value={this.state.renameNewValue}
                      onChange={this.handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="6">
                    <FormGroup>
                      <Button
                        color="secondary"
                        size="sm"
                        type="submit"
                        onClick={this.toggleConfirmationCopyMove}
                      >
                        Cancel
                      </Button>
                    </FormGroup>
                  </Col>
                  <Col lg="6" style={{ textAlign: "end", justifyContent: "end" }}>
                    <FormGroup>
                      <Button
                        color="primary"
                        size="sm"
                        type="submit"
                        onClick={e => this.renameCopyMoveUpdate(e)}
                      >
                        {this.state.modeTransfer === 'Copy'
                          ? <i className="fas fa-copy"></i>
                          : <i className="fas fa-file-export"></i>
                        }&nbsp;{this.state.modeTransfer}
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </ModalBody>
          </Modal>
          <Modal
            centered
            className="rename-modal"
            isOpen={this.state.showCopyMoveActionModal}
            toggle={this.toggleRenameCopyMoveAction}
            backdrop="static"
            returnFocusAfterClose={false}>
            <ModalHeader toggle={this.toggleRenameCopyMoveAction}>New Name</ModalHeader>
            <ModalBody>
              <Input
                placeholder="New Name"
                name="renameNewValue"
                className="inputRename"
                value={this.state.renameNewValue}
                onChange={this.handleChange}
              />
              <Row>
                <Col sm={12} lg={12} xl={8} className="renamepopHint">
                  <span className="notepopHint">Note: </span><span> Update reference of 'Renamed' folder/file in Project</span>
                </Col>
                <Col sm={12} lg={12} xl={4}>
                  <Button
                    size="sm"
                    color="primary"
                    className="storage-folder-btn renameBtn"
                    onClick={e => this.renameCopyMoveUpdate(e)}
                  >
                    Ok
                  </Button>
                </Col>
              </Row>

            </ModalBody>
          </Modal>
          <Drawer title="Pending Tasks" placement="right"
            width={650} style={{ marginTop: "50px" }}
            onClose={this.toggleTasks} visible={this.state.showTasksPanel}>
            <Card>
              <CardBody>
                <Row className="headerScheduler">
                  <Col xs="4">
                    <span title="Job Type" className="overflowStyle font13">Job Type</span>
                  </Col>
                  <Col xs="5">
                    <span title="Job Path" className="overflowStyle font13">Job Path</span>
                  </Col>
                  <Col xs="3">
                    <span title="Job Status" className="overflowStyle font13">Job Status</span>
                  </Col>
                </Row>
                <ListGroup className="scheduler-content">
                  {this.state.pendingDTOS.map((item, index) => (
                    <ListGroupItem key={index}>
                      <Row>
                        <Col className="d-flex align-items-center" xs="4">
                          <span title={item.jobType} className="overflow-pending-width font13">{item.jobType}</span>
                        </Col>
                        {(item.jobType === "MOVE" || item.jobType === "COPY") && <Col xs="5" className="mt-2">
                          <small title={item.jobInfo.paths !== null ? item.jobInfo.paths[0].sourcePath : "null"}
                            className="font-weight-bold text-primary overflow-pending-width actionicon">{item.jobInfo.paths !== null ? item.jobInfo.paths[0].sourcePath : "null"}</small>
                          <i className="fas fa-arrow-down pl-3 text-gray-dark"></i>
                          <small title={item.jobInfo.destinationPath}
                            className="font-weight-bold text-primary overflow-pending-width actionicon">{item.jobInfo.destinationPath}</small>
                        </Col>}
                        {item.jobType === "RENAME" && <Col xs="5" className="mt-2">
                          <small title={item.jobInfo.sourcePath}
                            className="font-weight-bold text-primary overflow-pending-width actionicon">{item.jobInfo.sourcePath}</small>
                          <i className="fas fa-arrow-down pl-3 text-gray-dark"></i>
                          <small title={item.jobInfo.newName}
                            className="font-weight-bold text-primary overflow-pending-width actionicon">{item.jobInfo.newName}</small>
                        </Col>}
                        {(item.jobType === "MOVE_TO_TRASH" || item.jobType === "RESTORE") && <Col xs="5" className="mt-2">
                          <small title={item.jobInfo.paths !== null ? item.jobInfo.paths[0].sourcePath : "null"}
                            className="font-weight-bold text-primary overflow-pending-width actionicon">{item.jobInfo.paths !== null ? item.jobInfo.paths[0].sourcePath : "null"}</small>
                        </Col>}
                        {(item.jobType === "FILE_EXTRACTION") && <Col xs="5" className="mt-2">
                          <small title={item.jobInfo.destinationPath}
                            className="font-weight-bold text-primary overflow-pending-width actionicon">{item.jobInfo.destinationPath}</small>
                        </Col>}
                        {(item.jobType === "DELETE") && <Col xs="5" className="mt-2"><smal>--</smal></Col>}
                        <Col className="d-flex align-items-center" xs="3">
                          <span title={item.jobState} className="overflow-pending-width font13">{item.jobState}</span>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  ))}
                  {this.state.pendingDTOS.length === 0 && <Col className="d-flex justify-content-center p-2">
                    <div>
                      <span>{this.state.errorMessage}</span>
                    </div>
                  </Col>
                  }
                </ListGroup>
              </CardBody>
              <Pagination
                pages={this.state.totalPagesPending}
                page={this.state.currentPageNumber}
                onPageChange={this.onPageChange}
                previousText="Previous"
                nextText="Next"
              />
            </Card>
          </Drawer>
        </div>
      </>

    );
  }
}

export default Storageui;
